function filtrerParfumsPrix(query) {
  const q = (query || '').toLowerCase().trim();
  if (!q) { renderListeParfumsPrix([], true); return; }
  // Recherche multi-mots : « MFK BR540 » ou « BR540 EDP » doivent fonctionner. Chaque mot doit
  // se retrouver dans marque + nom + concentration (sinon « marque nom » ne matchait jamais).
  const mots = q.split(/\s+/).filter(Boolean);
  const filtered = prixListeParfums.filter(p => {
    const cible = ((p.marque || '') + ' ' + (p.nom || '') + ' ' + (p.type_olfactif || '')).toLowerCase();
    return mots.every(m => cible.includes(m));
  });
  renderListeParfumsPrix(filtered, false);
}

function renderListeParfumsPrix(list, rechercheVide) {
  const container = document.getElementById('prix-liste-parfums');
  if (!list.length) {
    container.innerHTML = rechercheVide
      ? '<div class="empty"><div class="empty-icon">🔍</div><p>Tape un nom de marque ou de parfum pour voir les statistiques de prix.</p></div>'
      : '<div class="empty"><div class="empty-icon">🔍</div><p>Aucune référence trouvée avec un historique d\'achat.</p></div>';
    return;
  }

  // Regrouper par marque+nom : une même référence existe parfois en Blister, Tester et
  // Décant — on évite d'afficher 3 lignes quasi identiques, et on propose un bouton par
  // format disponible pour choisir directement lequel consulter.
  const groupes = {};
  list.forEach(p => {
    const gkey = p.marque + '||' + p.nom;
    if (!groupes[gkey]) groupes[gkey] = { marque: p.marque, nom: p.nom, formats: [] };
    groupes[gkey].formats.push(p);
  });

  const typeLabel = t => t === 'blister' ? 'Blister' : t === 'tester' ? 'Tester' : 'Décant';
  container.innerHTML = Object.values(groupes).map(g => {
    const boutons = g.formats.map(p =>
      '<button type="button" onclick="event.stopPropagation();selectParfumPrix(\'' + p.id + '\')" style="padding:4px 10px;border-radius:20px;border:1px solid var(--border2);background:var(--bg3);color:var(--text2);font-size:11px;cursor:pointer;font-family:var(--font);white-space:nowrap;margin-right:6px;margin-top:6px">' +
        typeLabel(p.type_produit) + (p.contenance_ml ? ' ' + p.contenance_ml + 'ml' : '') + (p.type_olfactif ? ' — ' + p.type_olfactif : '') +
      '</button>'
    ).join('');
    return '<div class="search-result-item" style="cursor:default">' +
      '<div class="item-name">' + g.marque + ' — ' + g.nom + '</div>' +
      '<div style="display:flex;flex-wrap:wrap">' + boutons + '</div>' +
    '</div>';
  }).join('');
}

function resetPrixFiche() {
  prixSelectedParfum = null;
  document.getElementById('prix-fiche').style.display = 'none';
}

async function selectParfumPrix(id) {
  const p = prixListeParfums.find(x => x.id === id);
  if (!p) return;
  prixSelectedParfum = p;

  const { data: achats } = await sb.from('achats').select('*').eq('parfum_id', id).order('date_achat', { ascending: true }).order('created_at', { ascending: true });
  const liste = achats || [];
  const { data: ventesData } = await sb.from('ventes').select('*').eq('parfum_id', id).order('date_vente', { ascending: true });
  const listeVentes = ventesData || [];

  const typeLabel = p.type_produit === 'blister' ? 'Blister' : p.type_produit === 'tester' ? 'Tester' : 'Décant';
  document.querySelector('#prix-fiche-title span').textContent = p.marque + ' ' + p.nom + (p.contenance_ml ? ' — ' + p.contenance_ml + 'ml' : '') + ' — ' + typeLabel;

  // Exclus du calcul min/max/moyenne : "Exceptionnel" (prix hors normes) et "Gratuit/Offert"
  // (prix à 0). On exclut AUSSI les décants issus d'une ouverture ou d'un échange dont le flacon
  // SOURCE était gratuit ou exceptionnel : leur prix hérité fausserait la moyenne.
  const sourceHorsStats = a => {
    if (a.type_achat === 'ouverture' && a.conversion_source) {
      const ts = a.conversion_source.type_achat;
      return ts === 'gratuit' || ts === 'exceptionnel';
    }
    if (a.type_achat === 'echange' && a.echange_source) {
      // Un échange est hors stats si TOUS ses lots sources étaient gratuits/exceptionnels
      const ops = a.echange_source.operations || [];
      if (ops.length) return ops.every(op => op.type_achat === 'gratuit' || op.type_achat === 'exceptionnel');
    }
    return false;
  };
  const prixStandard = liste.filter(a =>
    a.type_achat !== 'exceptionnel' && a.type_achat !== 'gratuit' && !sourceHorsStats(a)
  );
  // Point 1 : s'il n'y a AUCUN achat standard, on affiche EN ATTENDANT les achats
  // non-standard (exceptionnel/gratuit) à titre indicatif. Dès qu'un achat standard
  // existe, on ne garde que les standard (les non-standard sont masqués).
  const fallbackAchat = prixStandard.length === 0;
  const prixRetenus = fallbackAchat ? liste.slice() : prixStandard;

  let statsHtml;
  if (!prixRetenus.length) {
    statsHtml = '<div class="info-box">Aucun achat enregistré pour cette référence.</div>';
  } else {
    const prix = prixRetenus.map(a => a.prix_unitaire);
    const min = Math.min(...prix);
    const max = Math.max(...prix);
    // Moyenne pondérée par quantité : chaque unité achetée compte, pas juste chaque ligne
    // d'achat — un lot de 2 unités à 70€ pèse deux fois plus qu'un lot de 1 unité à 100€,
    // ce qui reflète le vrai coût moyen payé par unité sur l'ensemble du stock.
    const totalQte = prixRetenus.reduce((s, a) => s + a.quantite, 0);
    const totalMontant = prixRetenus.reduce((s, a) => s + a.prix_unitaire * a.quantite, 0);
    const moy = totalQte > 0 ? totalMontant / totalQte : 0;
    const fmt = v => v.toFixed(v % 1 === 0 ? 0 : 2) + ' €';
    statsHtml =
      (fallbackAchat ? '<div class="info-box" style="margin-bottom:14px;font-size:12px">🎁 Prix indicatifs (achats Exceptionnel/Gratuit uniquement). Ils seront remplacés par les statistiques réelles dès le premier achat Standard.</div>' : '') +
      '<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:20px">' +
        '<div style="background:var(--bg3);border-radius:var(--radius);padding:14px;text-align:center">' +
          '<div style="color:var(--text3);font-size:11px;text-transform:uppercase;letter-spacing:.5px;margin-bottom:6px">Min</div>' +
          '<div style="color:var(--text);font-size:18px;font-weight:700">' + fmt(min) + '</div>' +
        '</div>' +
        '<div style="background:var(--bg3);border-radius:var(--radius);padding:14px;text-align:center">' +
          '<div style="color:var(--text3);font-size:11px;text-transform:uppercase;letter-spacing:.5px;margin-bottom:6px">Max</div>' +
          '<div style="color:var(--text);font-size:18px;font-weight:700">' + fmt(max) + '</div>' +
        '</div>' +
        '<div style="background:var(--gold-bg);border:1px solid rgba(201,168,76,0.3);border-radius:var(--radius);padding:14px;text-align:center">' +
          '<div style="color:var(--gold);font-size:11px;text-transform:uppercase;letter-spacing:.5px;margin-bottom:6px">Moyenne</div>' +
          '<div style="color:var(--gold);font-size:18px;font-weight:700">' + fmt(moy) + '</div>' +
        '</div>' +
      '</div>';
  }

  const graphiqueHtml = prixRetenus.length ? renderGraphiquePrix(prixRetenus) : '';

  // ── STATS DE PRIX DE VENTE ──
  const fmt2 = v => v.toFixed(v % 1 === 0 ? 0 : 2) + ' €';
  // Exclure les ventes "revendeur" et "offert" (prix volontairement bas / nul) des stats.
  const ventesStandard = listeVentes.filter(v => v.type_vente !== 'revendeur' && v.type_vente !== 'offert');
  // Point 1 : si AUCUNE vente standard, afficher EN ATTENDANT toutes les ventes
  // (revendeur/offert) à titre indicatif ; masquées dès qu'une vente standard existe.
  const fallbackVente = ventesStandard.length === 0;
  const ventesRetenues = fallbackVente ? (listeVentes || []).slice() : ventesStandard;
  let statsVenteHtml = '';
  if (ventesRetenues.length) {
    const prixV = ventesRetenues.map(v => v.prix_unitaire);
    const minV = Math.min(...prixV);
    const maxV = Math.max(...prixV);
    const totalQteV = ventesRetenues.reduce((s, v) => s + v.quantite, 0);
    const totalMontantV = ventesRetenues.reduce((s, v) => s + v.prix_unitaire * v.quantite, 0);
    const moyV = totalQteV > 0 ? totalMontantV / totalQteV : 0;

    statsVenteHtml =
      '<div style="border-top:1px solid var(--border2);margin:24px 0 16px"></div>' +
      '<div class="card-title" style="font-size:14px;margin-bottom:12px;color:var(--green)">💰 Prix de vente</div>' +
      (fallbackVente ? '<div class="info-box" style="margin-bottom:14px;font-size:12px">🎁 Prix indicatifs (ventes Revendeur/Offert uniquement). Remplacés par les statistiques réelles dès la première vente Standard.</div>' : '') +
      '<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:16px">' +
        '<div style="background:var(--bg3);border-radius:var(--radius);padding:14px;text-align:center">' +
          '<div style="color:var(--text3);font-size:11px;text-transform:uppercase;letter-spacing:.5px;margin-bottom:6px">Min vente</div>' +
          '<div style="color:var(--text);font-size:18px;font-weight:700">' + fmt2(minV) + '</div>' +
        '</div>' +
        '<div style="background:var(--bg3);border-radius:var(--radius);padding:14px;text-align:center">' +
          '<div style="color:var(--text3);font-size:11px;text-transform:uppercase;letter-spacing:.5px;margin-bottom:6px">Max vente</div>' +
          '<div style="color:var(--text);font-size:18px;font-weight:700">' + fmt2(maxV) + '</div>' +
        '</div>' +
        '<div style="background:var(--green-bg);border:1px solid rgba(76,175,130,0.3);border-radius:var(--radius);padding:14px;text-align:center">' +
          '<div style="color:var(--green);font-size:11px;text-transform:uppercase;letter-spacing:.5px;margin-bottom:6px">Moyenne vente</div>' +
          '<div style="color:var(--green);font-size:18px;font-weight:700">' + fmt2(moyV) + '</div>' +
        '</div>' +
      '</div>';

    // ── ENCART MARGE (si on a un prix d'achat moyen ET un prix de vente moyen) ──
    if (prixRetenus.length) {
      const totalQteA = prixRetenus.reduce((s, a) => s + a.quantite, 0);
      const moyAchat = totalQteA > 0 ? prixRetenus.reduce((s, a) => s + a.prix_unitaire * a.quantite, 0) / totalQteA : 0;
      const marge = moyV - moyAchat;
      const margePct = moyAchat > 0 ? (marge / moyAchat * 100) : 0;
      const margeColor = marge > 0 ? 'var(--green)' : marge < 0 ? 'var(--red)' : 'var(--text2)';
      const margeSigne = marge > 0 ? '+' : '';
      statsVenteHtml +=
        '<div style="background:linear-gradient(135deg,var(--gold-bg),var(--green-bg));border:1px solid rgba(201,168,76,0.3);border-radius:var(--radius);padding:16px;margin-bottom:20px;text-align:center">' +
          '<div style="color:var(--text3);font-size:11px;text-transform:uppercase;letter-spacing:.5px;margin-bottom:8px">Marge moyenne par unité (vente moy. − achat moy.)</div>' +
          '<div style="color:' + margeColor + ';font-size:24px;font-weight:700">' + margeSigne + fmt2(marge) + '</div>' +
          '<div style="color:' + margeColor + ';font-size:13px;margin-top:4px">' + margeSigne + margePct.toFixed(1) + '% sur le prix d\'achat moyen (' + fmt2(moyAchat) + ')</div>' +
        '</div>';
    }
  } else {
    statsVenteHtml =
      '<div style="border-top:1px solid var(--border2);margin:24px 0 16px"></div>' +
      '<div class="card-title" style="font-size:14px;margin-bottom:8px;color:var(--green)">💰 Prix de vente</div>' +
      '<div class="info-box">' + (listeVentes.length ? 'Uniquement des ventes "Revendeur" (exclues des stats) pour cette référence.' : 'Aucune vente enregistrée pour cette référence — pas encore de statistique de vente.') + '</div>';
  }

  const historiqueHtml = !liste.length ? '' :
    '<div class="card-title" style="font-size:14px;margin-top:8px">Historique des achats</div>' +
    '<div class="table-wrap"><table>' +
    '<thead><tr><th>Date</th><th>Qté/ML</th><th>Prix unit.</th><th>Type</th><th>Qui</th></tr></thead><tbody>' +
    liste.slice().reverse().map(a => {
      const dt = new Date(a.date_achat);
      const dateLabel = MOIS_COURT[dt.getMonth()] + ' ' + dt.getFullYear();
      const exclu = (a.type_achat === 'exceptionnel' || a.type_achat === 'gratuit');
      const badgeAchat = a.type_achat === 'exceptionnel' ? '<span class="badge" style="background:var(--amber-bg);color:var(--amber);border:1px solid rgba(232,168,76,0.3)">Excep.</span>'
        : a.type_achat === 'gratuit' ? '<span class="badge badge-site">Gratuit</span>'
        : a.type_achat === 'ouverture' ? '<span class="badge badge-decant">Ouverture</span>'
        : a.type_achat === 'echange' ? '<span class="badge" style="background:rgba(91,155,213,0.15);color:var(--blue);border:1px solid rgba(91,155,213,0.3)">Échange</span>'
        : '<span class="badge badge-reseaux">Standard</span>';
      const venteurLabel = a.vendeur === 'commun' ? 'Compte commun' : a.vendeur === 'personnalise' ? '⚖️ Réparti' : a.vendeur === 'marouane' ? 'Marouane' : 'Yassine';
      return '<tr' + (exclu ? ' style="opacity:0.55"' : '') + '>' +
        '<td>' + dateLabel + '</td>' +
        '<td>' + a.quantite + '</td>' +
        '<td>' + a.prix_unitaire.toFixed(2) + ' €' + (exclu ? ' <span style="color:var(--text3);font-size:11px">(non pris en compte)</span>' : '') + '</td>' +
        '<td>' + badgeAchat + '</td>' +
        '<td>' + venteurLabel + '</td>' +
      '</tr>';
    }).join('') +
    '</tbody></table></div>';

  const histVentesHtml = !listeVentes.length ? '' :
    '<div class="card-title" style="font-size:14px;margin-top:8px">Historique des ventes</div>' +
    '<div class="table-wrap"><table>' +
    '<thead><tr><th>Date</th><th>Qté/ML</th><th>Prix unit.</th><th>Type</th><th>Qui</th></tr></thead><tbody>' +
    listeVentes.slice().reverse().map(v => {
      const dt = new Date(v.date_vente);
      const dateLabel = MOIS_COURT[dt.getMonth()] + ' ' + dt.getFullYear();
      const typeVenteLabel = v.type_vente === 'revendeur'
        ? '<span class="badge" style="background:var(--amber-bg);color:var(--amber);border:1px solid rgba(232,168,76,0.3)">Revendeur</span>'
        : v.type_vente === 'offert'
        ? '<span class="badge" style="background:var(--amber-bg);color:var(--amber);border:1px solid rgba(232,168,76,0.3)">🎁 Offert</span>'
        : '<span class="badge badge-reseaux">Standard</span>';
      const venteurLabel = v.vendeur === 'commun' ? 'Compte commun'
        : v.vendeur === 'personnalise' ? '⚖️ Réparti'
        : v.vendeur === 'marouane' ? 'Marouane' : 'Yassine';
      const estRevendeur = v.type_vente === 'revendeur' || v.type_vente === 'offert';
      return '<tr' + (estRevendeur ? ' style="opacity:0.55"' : '') + '>' +
        '<td>' + dateLabel + '</td>' +
        '<td>' + v.quantite + '</td>' +
        '<td>' + v.prix_unitaire.toFixed(2) + ' €' + (estRevendeur ? ' <span style="color:var(--text3);font-size:11px">(revendeur, non pris en compte)</span>' : '') + '</td>' +
        '<td>' + typeVenteLabel + '</td>' +
        '<td>' + venteurLabel + '</td>' +
      '</tr>';
    }).join('') +
    '</tbody></table></div>';

  // ── DURÉE D'ÉCOULEMENT (rythme de vente + durée estimée du stock) ──
  const uniteEc = p.type_produit === 'decant' ? 'ml' : 'u';
  const totalVenduEc = listeVentes.reduce((s, v) => s + (v.quantite || 0), 0);
  const totalAcheteEc = liste.reduce((s, a) => s + (a.quantite || 0), 0);
  const stockActuelEc = totalAcheteEc - totalVenduEc;
  const cadreEc = (badge, bg, coul, lignes) =>
    '<div style="border-top:1px solid var(--border2);margin:24px 0 16px"></div>' +
    '<div class="card-title" style="font-size:14px;margin-bottom:12px">⏱️ Durée d\'écoulement</div>' +
    '<div style="background:' + bg + ';border:1px solid ' + coul + '55;border-radius:var(--radius);padding:16px">' +
      '<div style="display:inline-block;background:' + coul + ';color:#0f0f0f;font-size:12px;font-weight:700;padding:3px 10px;border-radius:20px;margin-bottom:6px">' + badge + '</div>' +
      lignes.map(l => '<div style="font-size:13px;color:var(--text2);margin-top:6px">' + l + '</div>').join('') +
    '</div>';
  let ecoulementHtml = '';
  try {
  // Découpage en CYCLES de stock : un réassort après un sold-out démarre un nouveau cycle.
  const eventsEc = [];
  liste.forEach(a => { if (a.date_achat) eventsEc.push({ date: a.date_achat, cr: a.created_at || '', qty: (a.quantite || 0), achat: true }); });
  listeVentes.forEach(v => { if (v.date_vente) eventsEc.push({ date: v.date_vente, cr: v.created_at || '', qty: -(v.quantite || 0), achat: false }); });
  eventsEc.sort((x, y) => (x.date || '').localeCompare(y.date || '') || (x.cr || '').localeCompare(y.cr || '') || (x.achat === y.achat ? 0 : x.achat ? -1 : 1));
  const moisEntreEc = (d1, d2) => { const a = new Date(d1), b = new Date(d2); if (isNaN(a) || isNaN(b)) return 0; return Math.max(0, (b.getFullYear() - a.getFullYear()) * 12 + (b.getMonth() - a.getMonth())); };
  const badgeDuree = d => d < 2 ? { t: '🟢 Rapide', c: '#4CAF82', bg: 'rgba(76,175,130,0.12)' } : d <= 6 ? { t: '🟠 Moyen', c: '#E8A84C', bg: 'rgba(232,168,76,0.12)' } : { t: '🔴 Lent', c: '#DC3545', bg: 'rgba(220,53,69,0.12)' };
  const fmtRythmeEc = (vendu, mois) => { const r = vendu / Math.max(1, mois); return (r >= 10 ? Math.round(r) : r.toFixed(1)) + ' ' + uniteEc + '/mois'; };
  let stkEc = 0, cStart = null, cVendu = 0, cFirstVente = null;
  const cyclesTermines = [];
  eventsEc.forEach(ev => {
    if (ev.achat && stkEc <= 0) { cStart = ev.date; cVendu = 0; cFirstVente = null; }
    stkEc += ev.qty;
    if (!ev.achat) { cVendu += -ev.qty; if (!cFirstVente) cFirstVente = ev.date; }
    if (stkEc <= 0 && cStart) { cyclesTermines.push({ start: cStart, end: ev.date, vendu: cVendu, firstVente: cFirstVente }); cStart = null; }
  });
  const cycleOuvert = stkEc > 0 && cStart;
  const cyclePrec = cyclesTermines.length ? cyclesTermines[cyclesTermines.length - 1] : null;
  const ligneCyclePrec = (cyc) => { if (!cyc) return null; const d = moisEntreEc(cyc.start, cyc.end); const b = badgeDuree(d); const lbl = d === 0 ? 'moins d\'un mois' : '~' + d + ' mois'; return '📦 Stock précédent : écoulé en <strong>' + lbl + '</strong> \u2192 il était <strong style="color:' + b.c + '">' + b.t + '</strong>.'; };

  if (totalVenduEc === 0) {
    ecoulementHtml = cadreEc('💤 Dormant', 'var(--bg3)', '#9AA0A6', [
      'Aucune vente enregistrée : impossible d\'estimer un rythme.',
      stockActuelEc > 0 ? '<strong>' + stockActuelEc + ' ' + uniteEc + '</strong> en stock, immobilisés pour l\'instant.' : 'Pas de stock.'
    ]);
  } else if (cycleOuvert) {
    const dStart = new Date(cStart);
    const achatLbl = MOIS_COURT[dStart.getMonth()] + ' ' + dStart.getFullYear();
    const estReassort = cyclesTermines.length > 0;
    const entete = estReassort ? 'Nouveau stock depuis ' + achatLbl + '.' : null;
    const lignePrec = estReassort ? ligneCyclePrec(cyclePrec) : null;
    if (cVendu === 0) {
      ecoulementHtml = cadreEc('💤 Dormant (nouveau stock)', 'var(--bg3)', '#9AA0A6', [
        entete, 'Réassort en ' + achatLbl + ', <strong>' + stockActuelEc + ' ' + uniteEc + '</strong> en stock, aucune vente depuis.', lignePrec
      ].filter(Boolean));
    } else {
      const nowStr = new Date().toISOString().slice(0, 10);
      const moisCycle = moisEntreEc(cStart, nowStr) + 1;
      const rythme = cVendu / Math.max(1, moisCycle);
      const ligneRythme = 'Rythme de vente : <strong>~' + fmtRythmeEc(cVendu, moisCycle) + '</strong> (depuis ' + (estReassort ? 'le réassort' : 'le 1er achat') + ' en ' + achatLbl + ').';
      const delai = cFirstVente ? moisEntreEc(cStart, cFirstVente) : 0;
      const ligneDelai = delai >= 1 ? '\u23F3 ~' + delai + ' mois entre ' + (estReassort ? 'le réassort' : 'l\'achat') + ' et la 1\u00E8re vente.' : null;
      const duree = stockActuelEc / rythme;
      const dureeLbl = duree < 1 ? 'moins d\'un mois' : duree < 12 ? '~' + (duree < 3 ? duree.toFixed(1) : Math.round(duree)) + ' mois' : '~' + (duree / 12).toFixed(1) + ' an(s)';
      const b = badgeDuree(duree);
      ecoulementHtml = cadreEc(b.t, b.bg, b.c, [
        entete, ligneRythme, ligneDelai,
        'Stock actuel : <strong>' + stockActuelEc + ' ' + uniteEc + '</strong>.',
        'À ce rythme, il s\'écoulera en <strong>' + dureeLbl + '</strong>.', lignePrec
      ].filter(Boolean));
    }
  } else {
    const dc = cyclePrec || { start: (liste.map(a => a.date_achat).filter(Boolean).sort()[0]), end: (listeVentes.map(v => v.date_vente).filter(Boolean).sort().slice(-1)[0]), vendu: totalVenduEc, firstVente: (listeVentes.map(v => v.date_vente).filter(Boolean).sort()[0]) };
    const dureeVente = moisEntreEc(dc.start, dc.end);
    const ligneRythme = 'Rythme de vente : <strong>~' + fmtRythmeEc(dc.vendu, Math.max(1, dureeVente)) + '</strong> (sur la période où il était en stock).';
    const delai = dc.firstVente ? moisEntreEc(dc.start, dc.firstVente) : 0;
    const ligneDelai = delai >= 1 ? '\u23F3 ~' + delai + ' mois entre l\'achat et la 1\u00E8re vente.' : null;
    const b = badgeDuree(dureeVente);
    const dvLbl = dureeVente === 0 ? 'moins d\'un mois' : '~' + dureeVente + ' mois';
    const ligneNiveau = 'Tout a été vendu en <strong>' + dvLbl + '</strong> \u2192 il était <strong style="color:' + b.c + '">' + b.t + '</strong> quand il était en stock.';
    const cycleAvant = cyclesTermines.length >= 2 ? cyclesTermines[cyclesTermines.length - 2] : null;
    let lignePrec2 = null;
    if (cycleAvant) { const d2 = moisEntreEc(cycleAvant.start, cycleAvant.end); const b2 = badgeDuree(d2); const lbl2 = d2 === 0 ? 'moins d\'un mois' : '~' + d2 + ' mois'; lignePrec2 = '📦 Cycle précédent : écoulé en <strong>' + lbl2 + '</strong> \u2192 il était <strong style="color:' + b2.c + '">' + b2.t + '</strong>.'; }
    ecoulementHtml = cadreEc('\u2705 Écoulé', 'rgba(76,175,130,0.12)', '#4CAF82', [ligneRythme, ligneDelai, ligneNiveau, lignePrec2, 'Plus de stock à écouler aujourd\'hui.'].filter(Boolean));
  }
  } catch (eEc) {
    console.error('Erreur calcul ecoulement:', eEc);
    ecoulementHtml = '<div style="border-top:1px solid var(--border2);margin:24px 0 16px"></div><div class="card-title" style="font-size:14px">⏱️ Durée d\'écoulement</div><div style="color:var(--text3);font-size:12px">Indisponible pour cette référence.</div>';
  }

  document.getElementById('prix-fiche-content').innerHTML = statsHtml + statsVenteHtml + ecoulementHtml + renderGraphiqueEvolution(liste, listeVentes) + historiqueHtml + histVentesHtml;
  document.getElementById('prix-fiche').style.display = 'block';
}

// Graphique SVG simple d'évolution du prix unitaire dans le temps, dans le style sombre/doré
// de l'app. Pas de dépendance externe — tracé à la main pour rester dans ce fichier unique.
// Graphique SVG simple d'évolution du prix unitaire dans le temps, dans le style sombre/doré
// de l'app. Pas de dépendance externe — tracé à la main pour rester dans ce fichier unique.
// Les achats sont regroupés par mois+année : si plusieurs achats existent sur un même mois,
// on affiche la moyenne pondérée par quantité de ce mois plutôt qu'un point par achat — plus
// lisible, et cohérent avec le calcul des stats globales de la fiche. Seuls les mois ayant
// réellement eu un achat apparaissent sur l'axe (pas de mois vides), et chaque point porte son
// année pour rester clair même si les achats s'étalent sur plusieurs années.
// Graphique annuel : total dépensé (achats) vs total encaissé (ventes) par année, en SVG.
let fichePrixCourante = { liste: [], listeVentes: [] };

// Moyenne du prix (pondérée par la quantité) par mois, pour une année donnée.
function moyennesParMois(items, champDate, annee) {
  const acc = {};
  (items || []).forEach(it => {
    const d = new Date(it[champDate]);
    if (d.getFullYear() !== annee) return;
    const m = d.getMonth();
    if (!acc[m]) acc[m] = { montant: 0, qte: 0 };
    acc[m].montant += (it.prix_unitaire || 0) * (it.quantite || 0);
    acc[m].qte += (it.quantite || 0);
  });
  const avg = {};
  Object.keys(acc).forEach(m => { if (acc[m].qte > 0) avg[m] = acc[m].montant / acc[m].qte; });
  return avg;
}

function svgEvolution(liste, listeVentes, annee) {
  // Achats : on privilégie les standard. Mais si AUCUN achat standard n'existe, on
  // affiche EN ATTENDANT les non-standard (gratuit/exceptionnel), comme dans les stats.
  const achatsStd = (liste || []).filter(a => a.type_achat !== 'gratuit' && a.type_achat !== 'exceptionnel');
  const achatsF = achatsStd.length ? achatsStd : (liste || []).slice();
  // Ventes : idem. Si aucune vente standard, on affiche les revendeur/offert en attendant.
  const ventesStd = (listeVentes || []).filter(v => v.type_vente !== 'revendeur' && v.type_vente !== 'offert');
  const ventesF = ventesStd.length ? ventesStd : (listeVentes || []).slice();
  const avgA = moyennesParMois(achatsF, 'date_achat', annee);
  const avgV = moyennesParMois(ventesF, 'date_vente', annee);
  const vals = [...Object.values(avgA), ...Object.values(avgV)];
  const maxBrut = Math.max(1, ...vals);
  const maxVal = maxBrut * 1.2; // marge en haut pour ne pas coller au plafond
  const H = 175, padTop = 14, padBottom = 30, plotH = H - padTop - padBottom;
  const groupW = 46, barW = 16, gap = 4;
  const W = 12 * groupW + 24;
  let svg = '<svg viewBox="0 0 ' + W + ' ' + H + '" width="100%" style="max-width:' + W + 'px;font-family:var(--font)">';
  for (let i = 0; i <= 2; i++) {
    const yy = padTop + plotH * i / 2;
    svg += '<line x1="18" y1="' + yy + '" x2="' + W + '" y2="' + yy + '" stroke="var(--border2)" stroke-width="0.5"/>';
    svg += '<text x="2" y="' + (yy + 3) + '" font-size="7" fill="var(--text3)">' + Math.round(maxVal * (1 - i / 2)) + '</text>';
  }
  const esc = t => t.replace(/'/g, "\\'");
  for (let m = 0; m < 12; m++) {
    const cx = 22 + m * groupW + (groupW - (2 * barW + gap)) / 2;
    if (avgA[m] !== undefined) {
      const ha = plotH * avgA[m] / maxVal, ya = padTop + plotH - ha;
      const lbl = MOIS_COURT[m] + ' ' + annee + ' \u2014 Achat moyen : ' + avgA[m].toFixed(2).replace('.', ',') + ' \u20ac';
      svg += '<rect x="' + cx + '" y="' + ya + '" width="' + barW + '" height="' + Math.max(1, ha) + '" rx="2" fill="var(--gold)" style="cursor:pointer" onclick="tipBarre(\'' + esc(lbl) + '\')"><title>' + lbl + '</title></rect>';
    }
    if (avgV[m] !== undefined) {
      const hv = plotH * avgV[m] / maxVal, yv = padTop + plotH - hv;
      const lbl = MOIS_COURT[m] + ' ' + annee + ' \u2014 Vente moyenne : ' + avgV[m].toFixed(2).replace('.', ',') + ' \u20ac';
      svg += '<rect x="' + (cx + barW + gap) + '" y="' + yv + '" width="' + barW + '" height="' + Math.max(1, hv) + '" rx="2" fill="var(--green)" style="cursor:pointer" onclick="tipBarre(\'' + esc(lbl) + '\')"><title>' + lbl + '</title></rect>';
    }
    svg += '<text x="' + (22 + m * groupW + groupW / 2) + '" y="' + (H - 10) + '" text-anchor="middle" font-size="8" fill="var(--text2)">' + MOIS_COURT[m].slice(0, 3) + '</text>';
  }
  svg += '</svg>';
  return svg;
}

// Graphique d'évolution du PRIX MOYEN par mois, avec sélecteur d'année. Survole une barre pour le prix exact.
function renderGraphiqueEvolution(liste, listeVentes, annee) {
  fichePrixCourante = { liste: liste || [], listeVentes: listeVentes || [] };
  const annees = [...new Set([
    ...(liste || []).map(a => new Date(a.date_achat).getFullYear()),
    ...(listeVentes || []).map(v => new Date(v.date_vente).getFullYear())
  ])].sort((a, b) => a - b);
  if (!annees.length) return '';
  if (!annee || !annees.includes(annee)) annee = annees[annees.length - 1];
  return '<div style="border-top:1px solid var(--border2);margin:24px 0 12px"></div>' +
    '<div style="display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:8px;margin-bottom:6px">' +
      '<div class="card-title" style="font-size:14px;margin:0">Evolution du prix moyen par mois</div>' +
      '<select class="form-input" style="width:auto;padding:6px 10px" onchange="changerAnneeGraphique(parseInt(this.value))">' +
        annees.map(a => '<option value="' + a + '"' + (a === annee ? ' selected' : '') + '>' + a + '</option>').join('') +
      '</select>' +
    '</div>' +
    '<div style="color:var(--text3);font-size:11px;margin-bottom:8px">Survole ou appuie sur une barre pour voir le prix moyen exact.</div>' +
    '<div style="display:flex;gap:16px;margin-bottom:8px;font-size:12px">' +
      '<span style="color:var(--text2)"><span style="display:inline-block;width:10px;height:10px;background:var(--gold);border-radius:2px;vertical-align:middle;margin-right:4px"></span>Prix achat moyen</span>' +
      '<span style="color:var(--text2)"><span style="display:inline-block;width:10px;height:10px;background:var(--green);border-radius:2px;vertical-align:middle;margin-right:4px"></span>Prix vente moyen</span>' +
    '</div>' +
    '<div class="table-wrap" id="graph-evolution-svg">' + svgEvolution(liste, listeVentes, annee) + '</div>' +
    '<div id="graph-evolution-tip" style="min-height:18px;margin-top:8px;font-size:13px;font-weight:600;color:var(--gold);text-align:center"></div>';
}

function tipBarre(t) { const el = document.getElementById('graph-evolution-tip'); if (el) el.textContent = t; }

// Repositionne les infobulles d'aide pour qu'elles restent entièrement dans l'écran.
function clampBubble(bubble) {
  if (!bubble) return;
  bubble.style.transform = 'translateX(-50%)';
  const r = bubble.getBoundingClientRect();
  const pad = 10;
  let shift = 0;
  if (r.left < pad) shift = pad - r.left;
  else if (r.right > window.innerWidth - pad) shift = (window.innerWidth - pad) - r.right;
  if (Math.abs(shift) > 0.5) bubble.style.transform = 'translateX(calc(-50% + ' + Math.round(shift) + 'px))';
}
function clampAllBubbles() { document.querySelectorAll('.help-tip .help-bubble').forEach(clampBubble); }
document.addEventListener('pointerover', function (e) {
  const tip = e.target && e.target.closest ? e.target.closest('.help-tip') : null;
  if (tip) clampBubble(tip.querySelector('.help-bubble'));
});
window.addEventListener('resize', clampAllBubbles);
window.addEventListener('orientationchange', clampAllBubbles);

function changerAnneeGraphique(annee) {
  const c = document.getElementById('graph-evolution-svg');
  if (c) c.innerHTML = svgEvolution(fichePrixCourante.liste, fichePrixCourante.listeVentes, annee);
}

function renderGraphiquePrix(prixRetenus) {
  // Regroupement par clé "YYYY-MM"
  const parMois = {};
  prixRetenus.forEach(a => {
    const dt = new Date(a.date_achat);
    const cle = dt.getFullYear() + '-' + String(dt.getMonth()).padStart(2, '0');
    if (!parMois[cle]) parMois[cle] = { annee: dt.getFullYear(), mois: dt.getMonth(), totalQte: 0, totalMontant: 0 };
    parMois[cle].totalQte += a.quantite;
    parMois[cle].totalMontant += a.prix_unitaire * a.quantite;
  });

  const points = Object.keys(parMois).sort().map(cle => {
    const m = parMois[cle];
    return { annee: m.annee, mois: m.mois, prixMoyen: m.totalMontant / m.totalQte };
  });

  if (points.length < 2) return ''; // pas assez de mois distincts pour tracer une évolution

  const w = 600, h = 200, padL = 50, padR = 20, padT = 20, padB = 40;
  const valeurs = points.map(p => p.prixMoyen);
  const minV = Math.min(...valeurs), maxV = Math.max(...valeurs);
  const rangeV = (maxV - minV) || 1; // évite une division par 0 si tous les prix moyens sont identiques

  const x = i => padL + (i / (points.length - 1)) * (w - padL - padR);
  const y = v => padT + (1 - (v - minV) / rangeV) * (h - padT - padB);

  const ligne = points.map((p, i) => x(i) + ',' + y(p.prixMoyen)).join(' ');
  const cercles = points.map((p, i) =>
    '<circle cx="' + x(i) + '" cy="' + y(p.prixMoyen) + '" r="4" fill="#C9A84C" stroke="#0d0d0d" stroke-width="1.5"><title>' +
    MOIS_COURT[p.mois] + ' ' + p.annee + ' — ' + p.prixMoyen.toFixed(2) + '€</title></circle>'
  ).join('');

  // Labels sous chaque point, en alternant la hauteur si trop de points pour éviter qu'ils
  // se chevauchent (utile dès qu'il y a plus de 5-6 mois sur le graphique).
  const tropDePoints = points.length > 6;
  const labels = points.map((p, i) => {
    const decalageY = tropDePoints && i % 2 === 1 ? h - 6 : h - 18;
    return '<text x="' + x(i) + '" y="' + decalageY + '" fill="#8a8a8a" font-size="10" text-anchor="middle">' + MOIS_COURT[p.mois] + ' ' + p.annee + '</text>';
  }).join('');

  return '<div class="card-title" style="font-size:14px">Évolution du prix</div>' +
    '<svg viewBox="0 0 ' + w + ' ' + h + '" style="width:100%;height:auto;max-height:220px;background:var(--bg3);border-radius:var(--radius)">' +
      '<polyline points="' + ligne + '" fill="none" stroke="#C9A84C" stroke-width="2" />' +
      cercles + labels +
    '</svg>';
}

// ══════════════════════════════════════════
// CAGNOTTE — solde de compensation entre les deux associés (qui doit combien à qui)
// ══════════════════════════════════════════
// Convention du signe (vérifiée avec l'utilisateur) : un solde positif signifie que
// Marouane doit cette somme à Yassine ; un solde négatif signifie l'inverse. On n'affiche
// jamais le signe brut à l'écran, seulement un montant absolu accompagné d'une phrase claire.

// ── Dashboard : synthèse de l'activité et rentabilité ─────────────────────────

let dashboardMois = { y: new Date().getFullYear(), m: new Date().getMonth() };
let dashboardAnnee = new Date().getFullYear();
let classementCritere = 'qte';   // 'qte' | 'ca'
let classementPeriode = 'mois';  // 'mois' | 'annee' | 'global' | 'perso'
let classementDateDebut = '';
let classementDateFin = '';

// Petite bulle d'aide : "ⓘ" qui révèle une explication au survol
function tip(html) {
  return '<span class="help-tip">ⓘ<span class="help-bubble">' + html + '</span></span>';
}

function calculerIndicateurs(achats, ventes, charges, stock, filtreFn) {
  const f = filtreFn || (() => true);
  // Une ouverture/échange ne crée pas de cash neuf : elle transfère le coût du lot consommé
  // (supprimé/réduit) vers le nouveau lot. Pour que ce transfert reste INVISIBLE sur « Achats »,
  // le nouveau lot doit donc être compté à sa valeur, comme le lot d'origine. Seuls les gratuits = 0€.
  const cashAchat = (a) => (a.type_achat === 'gratuit') ? 0 : (a.montant_total || 0);
  const ca = ventes.filter(v => f(v.date_vente)).reduce((s, v) => s + (v.montant_total || 0), 0);
  const coutAchats = achats.filter(a => f(a.date_achat)).reduce((s, a) => s + cashAchat(a), 0);
  const totalCharges = charges.filter(c => f(c.date_charge)).reduce((s, c) => s + (c.montant || 0), 0);
  const benefice = ca - coutAchats - totalCharges;
  const rentabilite = ca > 0 ? (benefice / ca * 100) : null;
  const nbVentes = ventes.filter(v => f(v.date_vente)).length;
  const nbAchats = achats.filter(a => f(a.date_achat)).length;
  return { ca, coutAchats, totalCharges, benefice, rentabilite, nbVentes, nbAchats };
}

async function chargerDashboard() {
  const cont = document.getElementById('dashboard-content');
  cont.innerHTML = '<div class="loading"><div class="spinner"></div> Calcul des indicateurs...</div>';

  const [achats, ventes, charges, stockRes, cagList, parfumsList] = await Promise.all([
    selectTout('achats'),        // paginé : toutes les lignes (au-delà de 1000)
    selectTout('ventes'),        // paginé
    selectTout('charges'),       // paginé
    selectTout('stock_actuel'),   // paginé (avant : 1000 lignes au plus)
    selectTout('cagnotte', 'impact'),
    selectTout('parfums', 'id, marque, nom, type_produit, type_olfactif, contenance_ml')
  ]);
  const stock = stockRes || [];
  const cagRes = { data: cagList };
  const parfumInfo = {};
  (parfumsList || []).forEach(p => { parfumInfo[p.id] = p; });

  // Valeur du stock au PRIX D'ACHAT RÉEL des lots restants (pas le prix moyen).
  // Pour chaque parfum, on consomme les lots en FIFO (les plus récents d'abord, comme l'app)
  // jusqu'à atteindre la quantité totale vendue. Ce qui reste = lots × prix unitaire de chaque lot.
  const ventesParParfum = {};
  ventes.forEach(v => { ventesParParfum[v.parfum_id] = (ventesParParfum[v.parfum_id] || 0) + (v.quantite || 0); });
  const achatsParParfum = {};
  achats.forEach(a => {
    if (!achatsParParfum[a.parfum_id]) achatsParParfum[a.parfum_id] = [];
    achatsParParfum[a.parfum_id].push(a);
  });
  let stockValorise = 0;
  const stockRestantParParfum = {}; // qté restante par parfum
  const coutVenduParParfum = {};    // coût FIFO des unités vendues par parfum
  const stockValoParParfum = {};    // valeur du stock restant par parfum
  for (const parfumId in achatsParParfum) {
    // Trier FIFO : plus récent d'abord (date_achat DESC, created_at DESC) — comme dans l'app
    const lots = achatsParParfum[parfumId].slice().sort((x, y) =>
      (y.date_achat || '').localeCompare(x.date_achat || '') ||
      (y.created_at || '').localeCompare(x.created_at || ''));
    let resteVendu = ventesParParfum[parfumId] || 0;
    for (const lot of lots) {
      const qLot = lot.quantite || 0;
      const consomme = Math.min(resteVendu, qLot);
      const restant = qLot - consomme;
      resteVendu -= consomme;
      // Valeur du restant à son prix unitaire d'achat réel
      stockValorise += restant * (lot.prix_unitaire || 0);
      stockValoParParfum[parfumId] = (stockValoParParfum[parfumId] || 0) + restant * (lot.prix_unitaire || 0);
      stockRestantParParfum[parfumId] = (stockRestantParParfum[parfumId] || 0) + restant;
      coutVenduParParfum[parfumId] = (coutVenduParParfum[parfumId] || 0) + consomme * (lot.prix_unitaire || 0);
    }
  }

  const G = calculerIndicateurs(achats, ventes, charges, stock, null);
  const beneficeReel = G.benefice + stockValorise; // bénéfice + valeur du stock encore en main

  const soldeCag = (cagRes.data || []).reduce((s, m) => s + (m.impact || 0), 0);

  // ── Agrégats par parfum : rentabilité (#4) et projection revente (#5) ──
  const caParParfum = {}, qtyVendueParParfum = {}, venteMtStd = {}, venteQtStd = {};
  ventes.forEach(v => {
    const pid = v.parfum_id, montant = (v.prix_unitaire || 0) * (v.quantite || 0);
    caParParfum[pid] = (caParParfum[pid] || 0) + montant;
    qtyVendueParParfum[pid] = (qtyVendueParParfum[pid] || 0) + (v.quantite || 0);
    if (v.type_vente !== 'revendeur' && v.type_vente !== 'offert') { venteMtStd[pid] = (venteMtStd[pid] || 0) + montant; venteQtStd[pid] = (venteQtStd[pid] || 0) + (v.quantite || 0); }
  });
  const prixVenteMoyen = {};
  Object.keys(venteQtStd).forEach(pid => { if (venteQtStd[pid] > 0) prixVenteMoyen[pid] = venteMtStd[pid] / venteQtStd[pid]; });
  let valeurRevente = 0;
  Object.keys(stockRestantParParfum).forEach(pid => {
    const q = stockRestantParParfum[pid];
    if (q > 0 && prixVenteMoyen[pid]) valeurRevente += q * prixVenteMoyen[pid];
    else if (q > 0) valeurRevente += (stockValoParParfum[pid] || 0);
  });
  const beneficePotentiel = valeurRevente - stockValorise;

  // Mois sélectionné + mois précédent (pour tendances)
  const moisKey = dashboardMois.y + '-' + String(dashboardMois.m + 1).padStart(2, '0');
  const M = calculerIndicateurs(achats, ventes, charges, stock, (d) => (d || '').startsWith(moisKey));
  let pmY = dashboardMois.y, pmM = dashboardMois.m - 1;
  if (pmM < 0) { pmM = 11; pmY--; }
  const moisPrecKey = pmY + '-' + String(pmM + 1).padStart(2, '0');
  const MP = calculerIndicateurs(achats, ventes, charges, stock, (d) => (d || '').startsWith(moisPrecKey));
  // Même mois de l'année précédente (comparaison annuelle discrète)
  const moisAnPrecKey = (dashboardMois.y - 1) + '-' + String(dashboardMois.m + 1).padStart(2, '0');
  const MAP = calculerIndicateurs(achats, ventes, charges, stock, (d) => (d || '').startsWith(moisAnPrecKey));
  const moisAnPrecLabel = MOIS_COURT[dashboardMois.m] + ' ' + (dashboardMois.y - 1);
  // Le même mois de l'an dernier a-t-il des données ? Sinon, aucune comparaison possible.
  const mapVide = (MAP.ca === 0 && MAP.coutAchats === 0 && MAP.totalCharges === 0 && (MAP.nbVentes || 0) === 0);
  // Ligne discrète : variation vs même mois de l'année précédente (null si rien à comparer)
  const yoy = (actuel, precedent, positifEstBon, libelleAbsence) => {
    if (mapVide) return null;
    const base = 'font-size:10.5px;color:var(--text3)';
    const diff = (actuel || 0) - (precedent || 0);
    if (Math.abs(diff) < 0.01) return '<span style="' + base + '"><span style="color:var(--text3);font-weight:600">—</span> vs ' + moisAnPrecLabel + '</span>';
    if ((precedent || 0) === 0) return '<span style="' + base + '">' + (libelleAbsence || 'aucune donnée') + ' en ' + moisAnPrecLabel + '</span>';
    const monte = diff > 0;
    const bon = positifEstBon ? monte : !monte;
    const coul = bon ? 'var(--green)' : 'var(--red)';
    const variation = ((diff / Math.abs(precedent)) * 100).toFixed(0) + '%';
    const marque = (monte ? '↑' : '↓') + ' ' + (diff > 0 ? '+' : '') + variation;
    return '<span style="' + base + '"><span style="color:' + coul + ';font-weight:600">' + marque + '</span> vs ' + moisAnPrecLabel + '</span>';
  };

  // Flèche sémantique : VERT = amélioration, ROUGE = dégradation (selon la nature de la mesure).
  // positifEstBon=true  -> monter est bon (Ventes, Bénéfice).
  // positifEstBon=false -> descendre est bon (Achats, Charges : dépenser moins = mieux).
  const tendance = (actuel, precedent, positifEstBon) => {
    const diff = (actuel || 0) - (precedent || 0);
    if (Math.abs(diff) < 0.01) return ' <span style="color:var(--text2);font-size:13px;font-weight:600">—</span>';
    const monte = diff > 0;
    const bon = positifEstBon ? monte : !monte;
    return ' <span style="color:' + (bon ? 'var(--green)' : 'var(--red)') + ';font-size:12px;font-weight:600">' + (monte ? '↑' : '↓') + '</span>';
  };

  const eur = (n) => (n >= 0 ? '' : '-') + Math.abs(n).toFixed(2) + ' €';
  const couleurSigne = (n) => n > 0 ? 'var(--green)' : n < 0 ? 'var(--red)' : 'var(--text2)';
  const pct = (n) => n === null ? '—' : (n >= 0 ? '+' : '') + n.toFixed(1) + ' %';

  const grandeCarte = (label, valeur, couleur, sousTexte, tipHtml) =>
    '<div class="kpi-card kpi-card-lg">' +
    '<div class="kpi-label">' + label + (tipHtml ? tip(tipHtml) : '') + '</div>' +
    '<div class="kpi-value" style="color:' + (couleur || 'var(--text)') + '">' + valeur + '</div>' +
    (sousTexte ? '<div class="kpi-sub">' + sousTexte + '</div>' : '') + '</div>';
  const petiteCarte = (label, valeur, couleur, sousTexte, tipHtml) =>
    '<div class="kpi-card">' +
    '<div class="kpi-label">' + label + (tipHtml ? tip(tipHtml) : '') + '</div>' +
    '<div class="kpi-value kpi-value-sm" style="color:' + (couleur || 'var(--text)') + '">' + valeur + '</div>' +
    (sousTexte ? '<div class="kpi-sub">' + sousTexte + '</div>' : '') + '</div>';
  // Compteur discret à côté du titre d'une carte (ex: "Ventes (2)")
  const compteur = (n) => ' <span style="font-size:11px;font-weight:400;color:var(--text3)">(' + (n || 0) + ')</span>';

  let soldeTxt, soldeCoul;
  if (Math.abs(soldeCag) < 0.01) { soldeTxt = 'Équilibré ✅'; soldeCoul = 'var(--green)'; }
  else if (soldeCag > 0) { soldeTxt = 'Marouane doit ' + soldeCag.toFixed(2) + ' € à Yassine'; soldeCoul = 'var(--text)'; }
  else { soldeTxt = 'Yassine doit ' + Math.abs(soldeCag).toFixed(2) + ' € à Marouane'; soldeCoul = 'var(--text)'; }

  if (!ventes.length && !achats.length && !charges.length) {
    cont.innerHTML = '<div class="card"><div class="info-box">Aucune donnée pour l\'instant. Ajoute des achats, des ventes et des charges pour voir apparaître tes indicateurs de rentabilité ici.</div></div>';
    return;
  }

  let html = '';

  // ═══ SECTION 1 — RENTABILITÉ GLOBALE (3 cartes principales) ═══
  html += '<div class="card"><div class="card-title">📊 Rentabilité globale <span>(depuis le début)</span></div>';
  html += '<div class="kpi-row">';
  html += grandeCarte("Chiffre d'affaires", eur(G.ca), 'var(--gold)',
    ventes.length + ' vente' + (ventes.length > 1 ? 's' : ''),
    "<strong>Total de toutes tes ventes encaissées.</strong><br>C'est l'argent qui est rentré, depuis le début de l'activité.");
  html += grandeCarte("Bénéfice", eur(G.benefice), couleurSigne(G.benefice),
    'CA − Achats − Charges',
    "<strong>CA − Achats − Charges.</strong><br>Le bénéfice 'cash' : ce qu'il te reste après avoir payé le stock et les frais. <em>Peut être négatif si tu as investi en stock pas encore vendu.</em>");
  html += grandeCarte("Rentabilité", pct(G.rentabilite), couleurSigne(G.rentabilite || 0),
    'Bénéfice ÷ CA',
    "<strong>Bénéfice ÷ Chiffre d'affaires × 100.</strong><br>Sur chaque euro vendu, combien il te reste après tous les coûts. <strong>30% = très bon</strong>, 10% = modeste, négatif = tu perds de l'argent.");
  html += '</div></div>';

  // ═══ SECTION 2 — BÉNÉFICE RÉEL & STOCK (regard patrimonial) ═══
  html += '<div class="card"><div class="card-title">💎 Bénéfice réel <span>(en comptant la valeur du stock)</span></div>';
  html += '<div class="kpi-row">';
  html += grandeCarte("Bénéfice réel", eur(beneficeReel), couleurSigne(beneficeReel),
    'Bénéfice + Stock valorisé',
    "<strong>Bénéfice + Valeur du stock.</strong><br>Vision patrimoniale : ajoute la valeur du stock que tu as encore. <em>Plus optimiste que le bénéfice, mais plus juste si tu investis en stock.</em>");
  html += petiteCarte("Valeur du stock", eur(stockValorise), 'var(--gold)',
    'au prix d\'achat',
    "<strong>Valeur des lots encore en stock, au prix d'achat réel de chaque lot.</strong><br>Calculé en FIFO : on consomme les lots les plus récents d'abord par les ventes. Le restant est valorisé à son prix unitaire d'achat exact.");
  html += '</div></div>';

  // ═══ SECTION PROJECTION À LA REVENTE (#5) ═══
  html += '<div class="card"><div class="card-title">📈 Projection à la revente</div>';
  html += '<div class="kpi-row">';
  html += grandeCarte("Valeur à la revente", eur(valeurRevente), (valeurRevente > 0 ? 'var(--green)' : 'var(--text2)'), 'stock × prix de vente moyen',
    "<strong>Ce que tu encaisserais si tu vendais tout ton stock actuel</strong> au prix de vente moyen de chaque parfum (hors ventes revendeur). Pour un parfum jamais vendu, on prend son coût d'achat.");
  html += petiteCarte("Bénéfice potentiel", eur(beneficePotentiel), couleurSigne(beneficePotentiel), 'revente − coût du stock',
    "<strong>Le bénéfice qui « dort » dans ton stock</strong> : la valeur à la revente moins ce que ce stock t'a coûté. C'est le gain que tu réaliserais en écoulant tout ton stock.");
  html += '</div></div>';

  // ═══ SECTION RENTABILITÉ PAR PARFUM (#4) ═══
  const rentaRows = Object.keys(caParParfum).filter(pid => caParParfum[pid] > 0).map(pid => {
    const ca = caParParfum[pid], cout = coutVenduParParfum[pid] || 0, marge = ca - cout;
    const p = parfumInfo[pid] || {};
    return { pid: pid, nom: nomComplet(p), qty: qtyVendueParParfum[pid] || 0, type: p.type_produit, ca, cout, marge, margePct: ca > 0 ? marge / ca * 100 : 0, markup: cout > 0 ? marge / cout * 100 : 0 };
  }).sort((a, b) => b.marge - a.marge);
  window._rentaData = rentaRows;
  if (rentaRows.length) {
    html += '<div class="card"><div class="card-title">🏆 Rentabilité par parfum</div>';
    html += '<input type="text" class="form-input" placeholder="Rechercher un parfum à analyser…" style="margin-bottom:12px" oninput="renderRentaTable(this.value)">';
    html += '<div id="renta-table"></div>';
    html += '<div style="font-size:11px;color:var(--text3);margin-top:8px;padding:0 4px">Top 5 par marge · <strong>Marge</strong> = CA − coût réel (FIFO) des unités vendues · <strong>% CA</strong> = Marge ÷ CA · <strong>Marque</strong> = Marge ÷ Coût. Ventes revendeur incluses dans le CA.</div>';
    html += '</div>';
  }

  // ═══ CLASSEMENT DES PARFUMS (Top / Flop, par période) ═══
  const stockPP = {};
  stock.forEach(s => { stockPP[s.id] = s.stock_restant || 0; });
  window._classData = {
    ventes: ventes.map(v => ({ pid: v.parfum_id, date: v.date_vente, qte: v.quantite || 0, ca: v.montant_total || 0 })),
    parfumInfo, stockPP
  };
  html += '<div class="card"><div class="card-title">🏅 Classement des parfums</div>';
  html += '<div style="display:flex;gap:16px;flex-wrap:wrap;margin-bottom:12px">';
  html += '<div><div style="font-size:11px;color:var(--text3);margin-bottom:4px">Critère</div><div class="toggle-group" id="class-critere">' +
    '<button class="toggle-btn' + (classementCritere === 'qte' ? ' active' : '') + '" onclick="setClassementCritere(\'qte\')">Quantité</button>' +
    '<button class="toggle-btn' + (classementCritere === 'ca' ? ' active' : '') + '" onclick="setClassementCritere(\'ca\')">CA</button>' +
    '</div></div>';
  html += '<div><div style="font-size:11px;color:var(--text3);margin-bottom:4px">Période</div><div class="toggle-group" id="class-periode">' +
    '<button class="toggle-btn' + (classementPeriode === 'mois' ? ' active' : '') + '" onclick="setClassementPeriode(\'mois\')">Ce mois</button>' +
    '<button class="toggle-btn' + (classementPeriode === 'annee' ? ' active' : '') + '" onclick="setClassementPeriode(\'annee\')">Cette année</button>' +
    '<button class="toggle-btn' + (classementPeriode === 'global' ? ' active' : '') + '" onclick="setClassementPeriode(\'global\')">Global</button>' +
    '<button class="toggle-btn' + (classementPeriode === 'perso' ? ' active' : '') + '" onclick="setClassementPeriode(\'perso\')">Perso</button>' +
    '</div></div>';
  html += '</div>';
  html += '<div id="class-date-perso" style="display:' + (classementPeriode === 'perso' ? 'flex' : 'none') + ';gap:8px;align-items:center;flex-wrap:wrap;margin-bottom:12px">' +
    '<span style="font-size:12px;color:var(--text3)">Du</span><input type="date" class="form-input" value="' + classementDateDebut + '" onchange="setClassementDate(\'debut\',this.value)" style="width:auto;padding:5px 8px">' +
    '<span style="font-size:12px;color:var(--text3)">au</span><input type="date" class="form-input" value="' + classementDateFin + '" onchange="setClassementDate(\'fin\',this.value)" style="width:auto;padding:5px 8px">' +
    '</div>';
  html += '<input type="text" class="form-input" placeholder="Rechercher un parfum…" style="margin-bottom:12px" oninput="renderClassement(this.value)">';
  html += '<div id="classement-content"></div>';
  html += '</div>';

  // ═══ SECTION 3 — DÉTAIL DES FLUX ═══
  html += '<div class="card"><div class="card-title">💰 Détail des flux (depuis le début)</div>';
  html += '<div class="kpi-row">';
  html += petiteCarte('Ventes (CA)', eur(G.ca), 'var(--green)', null,
    "<strong>Argent rentré.</strong><br>Total des ventes (peu importe le vendeur, le canal, le type).");
  html += petiteCarte('Achats (stock)', eur(-G.coutAchats), 'var(--red)', null,
    "<strong>Cash investi dans le stock.</strong><br>Tous les lots comptent à leur valeur, sauf les gratuits (0€). Une ouverture ou un échange ne crée pas de cash neuf : le coût du lot consommé est simplement transféré vers le nouveau lot, donc le total reste stable.");
  html += petiteCarte('Charges', (G.totalCharges < 0 ? '+' + eur(-G.totalCharges).replace('-','') : eur(-G.totalCharges)), (G.totalCharges < 0 ? 'var(--green)' : (G.totalCharges > 0 ? 'var(--red)' : 'var(--text2)')), null,
    "<strong>Cash sorti pour les frais.</strong><br>Abonnements, envoi, packaging, pub, etc. Tout ce qui n'est pas du stock.");
  html += '</div></div>';

  // ═══ SECTION 4 — VUE MENSUELLE (avec sélecteur calendrier) ═══
  html += '<div class="card" style="position:relative">';
  html += '<div class="card-title" style="display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:8px">' +
    '<span>📅 Vue mensuelle</span>' +
    '<button class="btn btn-ghost btn-sm" onclick="dashToggleCalendar()" style="display:flex;align-items:center;gap:6px;font-weight:600">' +
    '📆 <span id="dash-cal-label">' + MOIS_COURT[dashboardMois.m] + ' ' + dashboardMois.y + '</span> <span style="font-size:10px">▾</span></button>' +
    '</div>';
  // Calendrier déroulant : TOUJOURS présent dans le DOM, simplement caché par défaut.
  // Le toggle ne recharge plus tout le dashboard (juste l'affichage).
  html += '<div id="dash-cal-wrap" style="display:none;background:var(--bg3);border:1px solid var(--border2);border-radius:var(--radius-lg);padding:16px;margin-bottom:16px">';
  html += '<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:12px">' +
    '<button class="btn btn-ghost btn-sm" onclick="dashCalNavYear(-1)">‹</button>' +
    '<span id="dash-cal-year" style="font-size:16px;font-weight:600;color:var(--text)">' + dashboardMois.y + '</span>' +
    '<button class="btn btn-ghost btn-sm" onclick="dashCalNavYear(1)">›</button>' +
    '</div>';
  html += '<div id="dash-cal-grid" style="display:grid;grid-template-columns:repeat(4,1fr);gap:6px">';
  for (let mi = 0; mi < 12; mi++) {
    const isActif = mi === dashboardMois.m;
    html += '<button class="btn btn-ghost" onclick="dashSelectMois(' + mi + ')" style="padding:10px;font-size:13px;' +
      (isActif ? 'background:var(--gold-bg);border:1px solid var(--gold);color:var(--gold);font-weight:600' : '') +
      '">' + MOIS_COURT[mi] + '</button>';
  }
  html += '</div></div>';
  html += '<div class="kpi-row">';
  html += petiteCarte('Ventes' + compteur(M.nbVentes), eur(M.ca) + tendance(M.ca, MP.ca, true), (M.ca > 0 ? 'var(--green)' : 'var(--text2)'),
    yoy(M.ca, MAP.ca, true, 'aucune vente'),
    "<strong>Ventes du mois sélectionné.</strong><br>La flèche compare avec le mois précédent, la petite ligne avec le même mois l'an dernier.");
  html += petiteCarte('Achats' + compteur(M.nbAchats), eur(-M.coutAchats) + tendance(M.coutAchats, MP.coutAchats, false), (M.coutAchats > 0 ? 'var(--red)' : 'var(--text2)'), yoy(M.coutAchats, MAP.coutAchats, false, 'aucun achat'),
    "<strong>Cash dépensé en stock ce mois-ci.</strong><br>Flèche rouge si en hausse (on dépense plus).");
  html += petiteCarte('Charges', (M.totalCharges < 0 ? '+' + eur(-M.totalCharges).replace('-','') : eur(-M.totalCharges)) + tendance(M.totalCharges, MP.totalCharges, false), (M.totalCharges < 0 ? 'var(--green)' : (M.totalCharges > 0 ? 'var(--red)' : 'var(--text2)')), yoy(M.totalCharges, MAP.totalCharges, false, 'aucune charge'),
    "<strong>Frais du mois.</strong><br>Flèche rouge si en hausse.");
  html += petiteCarte('Bénéfice', eur(M.benefice) + tendance(M.benefice, MP.benefice, true), couleurSigne(M.benefice), yoy(M.benefice, MAP.benefice, true, 'aucun bénéfice'),
    "<strong>CA − Achats − Charges du mois.</strong><br>Bénéfice 'cash' du mois.");
  if (M.rentabilite !== null) html += petiteCarte('Rentabilité', pct(M.rentabilite) + tendance(M.rentabilite, MP.rentabilite, true), couleurSigne(M.rentabilite), yoy(M.rentabilite, MAP.rentabilite, true, 'aucune rentabilité'),
    "<strong>Bénéfice ÷ CA du mois.</strong><br>Sur 1€ vendu, combien il te reste.");
  html += '</div>';
  html += '<div class="kpi-sub" style="margin-top:10px">' +
    (mapVide
      ? 'Flèche = vs ' + MOIS_COURT[pmM] + ' ' + pmY + ' (mois précédent). Pas de données en ' + moisAnPrecLabel + ' : comparaison annuelle indisponible.'
      : 'Flèche = vs ' + MOIS_COURT[pmM] + ' ' + pmY + ' (mois précédent). Petite ligne grise = vs ' + moisAnPrecLabel + ' (même mois l\'an dernier).') +
    '</div></div>';

  // ═══ SECTION 4bis — VUE ANNUELLE ═══
  const anKey = String(dashboardAnnee);
  const A = calculerIndicateurs(achats, ventes, charges, stock, (d) => (d || '').startsWith(anKey));
  const AP = calculerIndicateurs(achats, ventes, charges, stock, (d) => (d || '').startsWith(String(dashboardAnnee - 1)));
  html += '<div class="card">';
  html += '<div class="card-title" style="display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:8px">' +
    '<span>📊 Vue annuelle</span>' +
    '<span style="display:inline-flex;align-items:center;gap:8px">' +
      '<button class="btn btn-ghost btn-sm" onclick="dashAnneeNav(-1)">‹</button>' +
      '<span style="font-weight:700;font-size:15px;color:var(--gold)">' + dashboardAnnee + '</span>' +
      '<button class="btn btn-ghost btn-sm" onclick="dashAnneeNav(1)">›</button>' +
    '</span>' +
  '</div>';
  html += '<div class="kpi-row">';
  html += petiteCarte('Ventes' + compteur(A.nbVentes), eur(A.ca) + tendance(A.ca, AP.ca, true), (A.ca > 0 ? 'var(--green)' : 'var(--text2)'), null,
    "<strong>Total des ventes de l'année.</strong><br>La flèche compare avec l'année précédente.");
  html += petiteCarte('Achats' + compteur(A.nbAchats), eur(-A.coutAchats) + tendance(A.coutAchats, AP.coutAchats, false), (A.coutAchats > 0 ? 'var(--red)' : 'var(--text2)'), null,
    "<strong>Cash dépensé en stock sur l'année.</strong>");
  html += petiteCarte('Charges', (A.totalCharges < 0 ? '+' + eur(-A.totalCharges).replace('-','') : eur(-A.totalCharges)) + tendance(A.totalCharges, AP.totalCharges, false), (A.totalCharges < 0 ? 'var(--green)' : (A.totalCharges > 0 ? 'var(--red)' : 'var(--text2)')), null,
    "<strong>Frais de l'année.</strong>");
  html += petiteCarte('Bénéfice', eur(A.benefice) + tendance(A.benefice, AP.benefice, true), couleurSigne(A.benefice), null,
    "<strong>CA − Achats − Charges sur l'année.</strong>");
  if (A.rentabilite !== null) html += petiteCarte('Rentabilité', pct(A.rentabilite) + tendance(A.rentabilite, AP.rentabilite, true), couleurSigne(A.rentabilite), null,
    "<strong>Bénéfice ÷ CA de l'année.</strong>");
  html += '</div>';
  html += '<div class="kpi-sub" style="margin-top:10px">Les flèches comparent avec ' + (dashboardAnnee - 1) + '.</div></div>';

  // ═══ SECTION 5 — RÉCAP ANNUEL ═══
  html += '<div class="card"><div class="card-title">📆 Récapitulatif ' + dashboardAnnee + '</div>';
  html += '<div class="table-wrap"><table><thead><tr>' +
    '<th>Mois</th><th>Ventes</th><th>Achats</th><th>Charges</th><th>Bénéfice</th></tr></thead><tbody>';
  let totAnnee = { ca: 0, ach: 0, ch: 0, ben: 0 };
  for (let mi = 0; mi < 12; mi++) {
    const mk = dashboardAnnee + '-' + String(mi + 1).padStart(2, '0');
    const X = calculerIndicateurs(achats, ventes, charges, stock, (d) => (d || '').startsWith(mk));
    totAnnee.ca += X.ca; totAnnee.ach += X.coutAchats; totAnnee.ch += X.totalCharges; totAnnee.ben += X.benefice;
    const vide = X.ca === 0 && X.coutAchats === 0 && X.totalCharges === 0;
    const estMoisActif = mi === dashboardMois.m && dashboardAnnee === dashboardMois.y;
    html += '<tr' + (estMoisActif ? ' style="background:var(--gold-bg)"' : '') + '>' +
      '<td' + (estMoisActif ? ' style="font-weight:600;color:var(--gold)"' : '') + '>' + MOIS_COURT[mi] + '</td>' +
      '<td style="color:' + (X.ca > 0 ? 'var(--green)' : 'var(--text3)') + '">' + (X.ca ? X.ca.toFixed(2) + ' €' : '—') + '</td>' +
      '<td style="color:' + (X.coutAchats > 0 ? 'var(--red)' : 'var(--text3)') + '">' + (X.coutAchats ? '-' + X.coutAchats.toFixed(2) + ' €' : '—') + '</td>' +
      '<td style="color:' + (X.totalCharges < 0 ? 'var(--green)' : (X.totalCharges > 0 ? 'var(--red)' : 'var(--text3)')) + '">' + (X.totalCharges ? (X.totalCharges < 0 ? '+' + Math.abs(X.totalCharges).toFixed(2) : '-' + X.totalCharges.toFixed(2)) + ' €' : '—') + '</td>' +
      '<td style="font-weight:600;color:' + (vide ? 'var(--text3)' : couleurSigne(X.benefice)) + '">' + (vide ? '—' : eur(X.benefice)) + '</td>' +
      '</tr>';
  }
  html += '<tr style="border-top:2px solid var(--border2)">' +
    '<td style="font-weight:700">Total ' + dashboardAnnee + '</td>' +
    '<td style="font-weight:700;color:' + (totAnnee.ca > 0 ? 'var(--green)' : 'var(--text3)') + '">' + totAnnee.ca.toFixed(2) + ' €</td>' +
    '<td style="font-weight:700;color:' + (totAnnee.ach > 0 ? 'var(--red)' : 'var(--text3)') + '">-' + totAnnee.ach.toFixed(2) + ' €</td>' +
    '<td style="font-weight:700;color:' + (totAnnee.ch > 0 ? 'var(--red)' : 'var(--text3)') + '">-' + totAnnee.ch.toFixed(2) + ' €</td>' +
    '<td style="font-weight:700;color:' + couleurSigne(totAnnee.ben) + '">' + eur(totAnnee.ben) + '</td>' +
    '</tr></tbody></table></div></div>';

  // ═══ SECTION 6 — CAGNOTTE ═══
  html += '<div class="card"><div class="card-title">🤝 Cagnotte entre associés' +
    tip("<strong>Solde de votre cagnotte commune.</strong><br>Calculé automatiquement à partir des achats, ventes, charges et remboursements. Détail complet dans l'onglet Cagnotte.") + '</div>';
  html += '<div style="font-size:20px;font-weight:600;color:' + soldeCoul + ';padding:6px 0">' + soldeTxt + '</div></div>';

  // ═══ SECTION 7 — CHARGES PAR CATÉGORIE ═══
  const parCategorie = {};
  charges.forEach(c => { parCategorie[c.type_charge] = (parCategorie[c.type_charge] || 0) + (c.montant || 0); });
  const categoriesTriees = Object.entries(parCategorie).sort((a, b) => b[1] - a[1]);
  if (categoriesTriees.length) {
    const maxCat = categoriesTriees[0][1];
    const totalCh = categoriesTriees.reduce((s, [, m]) => s + m, 0);
    html += '<div class="card"><div class="card-title">💸 Charges par catégorie' +
      tip("Répartition de tes dépenses. La largeur de chaque barre est proportionnelle à la catégorie la plus grosse. Le % indique la part dans le total des charges.") + '</div>';
    html += categoriesTriees.map(([cat, montant]) => {
      const pctBar = maxCat > 0 ? (montant / maxCat * 100) : 0;
      const pctTotal = totalCh > 0 ? (montant / totalCh * 100) : 0;
      return '<div style="margin-bottom:10px">' +
        '<div style="display:flex;justify-content:space-between;font-size:13px;margin-bottom:3px">' +
        '<span style="color:var(--text2)">' + cat + '</span>' +
        '<span style="color:var(--text);font-weight:600">' + montant.toFixed(2) + ' € <span style="color:var(--text3);font-weight:400">(' + pctTotal.toFixed(0) + '%)</span></span></div>' +
        '<div style="height:8px;background:var(--bg3);border-radius:4px;overflow:hidden">' +
        '<div style="height:100%;width:' + pctBar + '%;background:var(--gold);border-radius:4px"></div></div></div>';
    }).join('');
    html += '</div>';
  }

  cont.innerHTML = html;
  if (window._rentaData && window._rentaData.length) renderRentaTable('');
  if (window._classData) renderClassement('');
  requestAnimationFrame(clampAllBubbles);
}

// Bascule l'affichage du calendrier sans recharger le dashboard.
function dashToggleCalendar() {
  const wrap = document.getElementById('dash-cal-wrap');
  if (wrap) wrap.style.display = wrap.style.display === 'none' ? 'block' : 'none';
}
// Changer d'année : redessiner juste la grille du calendrier (pas tout le dashboard).
function dashCalNavYear(dir) {
  dashboardMois.y += dir;
  const yearEl = document.getElementById('dash-cal-year');
  const gridEl = document.getElementById('dash-cal-grid');
  if (!yearEl || !gridEl) return;
  yearEl.textContent = dashboardMois.y;
  let html = '';
  for (let mi = 0; mi < 12; mi++) {
    const isActif = mi === dashboardMois.m;
    html += '<button class="btn btn-ghost" onclick="dashSelectMois(' + mi + ')" style="padding:10px;font-size:13px;' +
      (isActif ? 'background:var(--gold-bg);border:1px solid var(--gold);color:var(--gold);font-weight:600' : '') +
      '">' + MOIS_COURT[mi] + '</button>';
  }
  gridEl.innerHTML = html;
}
// Choisir un mois : on recharge le dashboard car la période change.
function dashSelectMois(mi) {
  dashboardMois.m = mi;
  chargerDashboard();
}
// Changer l'année de la vue annuelle + du récapitulatif.
function dashAnneeNav(dir) {
  dashboardAnnee += dir;
  chargerDashboard();
}

// ── Charges & dépenses ────────────────────────────────────────────────────────

let calChargeState = { selected: null, year: new Date().getFullYear() };
let chargeEditId = null;

function onChargeCategorieChange() {
  const sel = document.getElementById('charge-categorie');
  const custom = document.getElementById('charge-categorie-custom');
  custom.style.display = sel.value === 'Autre' ? 'block' : 'none';
}

function ouvrirAjoutCharge() {
  chargeEditId = null;
  document.getElementById('charge-modal-title').textContent = '💸 Ajouter une charge';
  document.getElementById('charge-categorie').value = '';
  document.getElementById('charge-categorie-custom').value = '';
  document.getElementById('charge-categorie-custom').style.display = 'none';
  document.getElementById('charge-montant').value = '';
  document.getElementById('charge-note').value = '';
  document.getElementById('charge-categorie-err').classList.remove('show');
  document.getElementById('charge-montant-err').classList.remove('show');
  document.querySelectorAll('#charge-payeur .toggle-btn').forEach(b => b.classList.remove('active'));
  document.querySelector('#charge-payeur .toggle-btn[data-val="les_deux"]').classList.add('active');
  majChargePayeurHint();
  const now = new Date();
  calChargeState = { selected: { m: now.getMonth(), y: now.getFullYear() }, year: now.getFullYear() };
  document.getElementById('charge-date-label').textContent = MOIS_COURT[now.getMonth()] + ' ' + now.getFullYear();
  document.getElementById('charge-date-label').style.color = 'var(--text)';
  document.getElementById('charge-cal-wrap').style.display = 'none';
  openModal('modal-charge');
}

function majChargePayeurHint() {
  const v = getToggleVal('charge-payeur');
  const hint = document.getElementById('charge-payeur-hint');
  if (v === 'les_deux') hint.textContent = 'Dépense commune : neutre sur la cagnotte (chacun paie sa moitié).';
  else if (v === 'marouane') hint.textContent = 'Marouane avance les frais : Yassine lui doit la moitié.';
  else if (v === 'yassine') hint.textContent = 'Yassine avance les frais : Marouane lui doit la moitié.';
  else hint.textContent = '';
}

// Recâbler le hint quand on change le payeur (les toggle ont déjà setToggleActive)
document.addEventListener('click', function(e) {
  if (e.target && e.target.closest && e.target.closest('#charge-payeur')) majChargePayeurHint();
});

function ouvrirCalendrierCharge() {
  const wrap = document.getElementById('charge-cal-wrap');
  wrap.style.display = wrap.style.display === 'none' ? 'block' : 'none';
  if (wrap.style.display === 'block') renderCalCharge();
}
function renderCalCharge() {
  document.getElementById('charge-cal-year').textContent = calChargeState.year;
  const grid = document.getElementById('charge-cal-months');
  grid.innerHTML = '';
  MOIS_COURT.forEach((m, i) => {
    const btn = document.createElement('button');
    btn.type = 'button'; btn.textContent = m;
    btn.style.cssText = 'padding:6px 2px;text-align:center;font-size:12px;border-radius:6px;cursor:pointer;border:1px solid transparent;background:none;font-family:var(--font);color:var(--text2)';
    if (calChargeState.selected && calChargeState.selected.m === i && calChargeState.selected.y === calChargeState.year) {
      btn.style.background = 'var(--gold-bg)'; btn.style.borderColor = 'var(--gold)'; btn.style.color = 'var(--gold)';
    }
    btn.onclick = () => {
      calChargeState.selected = { m: i, y: calChargeState.year };
      document.getElementById('charge-date-label').textContent = MOIS_COURT[i] + ' ' + calChargeState.year;
      document.getElementById('charge-date-label').style.color = 'var(--text)';
      document.getElementById('charge-cal-wrap').style.display = 'none';
    };
    grid.appendChild(btn);
  });
}
function calChargeNav(dir) { calChargeState.year += dir; renderCalCharge(); }

// ═══════════ REMBOURSEMENTS (recréé) ═══════════
let calRemboursState = { selected: null, year: new Date().getFullYear() };

let editRemboursementId = null; // null = création ; sinon = édition
function ouvrirRemboursement(idEdit) {
  editRemboursementId = idEdit || null;
  document.getElementById('rembours-montant').value = '';
  document.getElementById('rembours-note').value = '';
  document.getElementById('rembours-montant-err').classList.remove('show');
  document.querySelectorAll('#rembours-sens .toggle-btn').forEach(b => b.classList.remove('active'));
  // Titre + bouton adaptés au mode.
  const titre = document.querySelector('#modal-remboursement .modal-title');
  if (titre) titre.textContent = editRemboursementId ? '✏️ Modifier le remboursement' : '🤝 Enregistrer un remboursement';
  // En mode ÉDITION : pré-remplir depuis le mouvement connu.
  if (editRemboursementId) {
    const r = (window.__remboursementsCache || []).find(x => x.id === editRemboursementId);
    if (r) {
      document.getElementById('rembours-montant').value = r.montant;
      document.getElementById('rembours-note').value = r.note || '';
      document.querySelectorAll('#rembours-sens .toggle-btn').forEach(b => b.classList.toggle('active', b.getAttribute('data-val') === r.sens));
      const d = new Date(r.date_remboursement);
      calRemboursState = { selected: { m: d.getMonth(), y: d.getFullYear() }, year: d.getFullYear() };
      document.getElementById('rembours-date-label').textContent = MOIS_COURT[d.getMonth()] + ' ' + d.getFullYear();
      document.getElementById('rembours-date-label').style.color = 'var(--text)';
      document.getElementById('rembours-cal-wrap').style.display = 'none';
      document.getElementById('rembours-hint').innerHTML = 'Tu modifies un remboursement existant. La cagnotte sera recalculée.';
      openModal('modal-remboursement');
      return;
    }
  }
  let solde = 0;
  try { if (typeof allCagnotteMvts !== 'undefined') solde = r2c((allCagnotteMvts || []).reduce((s, m) => s + (m.impact || 0), 0)); } catch (e) {}
  const hint = document.getElementById('rembours-hint');
  if (solde > 0) hint.innerHTML = 'Solde actuel : <strong>Marouane doit ' + solde.toFixed(2) + ' € à Yassine</strong>. Un remboursement Marouane → Yassine rapproche la cagnotte de zéro.';
  else if (solde < 0) hint.innerHTML = 'Solde actuel : <strong>Yassine doit ' + Math.abs(solde).toFixed(2) + ' € à Marouane</strong>. Un remboursement Yassine → Marouane rapproche la cagnotte de zéro.';
  else hint.innerHTML = 'La cagnotte est équilibrée. Enregistre un remboursement si l\'un a versé de l\'argent à l\'autre.';
  const now = new Date();
  calRemboursState = { selected: { m: now.getMonth(), y: now.getFullYear() }, year: now.getFullYear() };
  document.getElementById('rembours-date-label').textContent = MOIS_COURT[now.getMonth()] + ' ' + now.getFullYear();
  document.getElementById('rembours-date-label').style.color = 'var(--text)';
  document.getElementById('rembours-cal-wrap').style.display = 'none';
  openModal('modal-remboursement');
}
function ouvrirCalendrierRembours() {
  const wrap = document.getElementById('rembours-cal-wrap');
  wrap.style.display = wrap.style.display === 'none' ? 'block' : 'none';
  if (wrap.style.display === 'block') renderCalRembours();
}
function renderCalRembours() {
  document.getElementById('rembours-cal-year').textContent = calRemboursState.year;
  const grid = document.getElementById('rembours-cal-months');
  grid.innerHTML = '';
  MOIS_COURT.forEach((m, i) => {
    const btn = document.createElement('button');
    btn.type = 'button'; btn.textContent = m;
    btn.style.cssText = 'padding:6px 2px;text-align:center;font-size:12px;border-radius:6px;cursor:pointer;border:1px solid transparent;background:none;font-family:var(--font);color:var(--text2)';
    if (calRemboursState.selected && calRemboursState.selected.m === i && calRemboursState.selected.y === calRemboursState.year) {
      btn.style.background = 'var(--gold-bg)'; btn.style.borderColor = 'var(--gold)'; btn.style.color = 'var(--gold)';
    }
    btn.onclick = () => {
      calRemboursState.selected = { m: i, y: calRemboursState.year };
      document.getElementById('rembours-date-label').textContent = MOIS_COURT[i] + ' ' + calRemboursState.year;
      document.getElementById('rembours-date-label').style.color = 'var(--text)';
      document.getElementById('rembours-cal-wrap').style.display = 'none';
    };
    grid.appendChild(btn);
  });
}
function calRemboursNav(dir) { calRemboursState.year += dir; renderCalRembours(); }

async function enregistrerRemboursement() {
  const montant = parseFloat(document.getElementById('rembours-montant').value);
  const sens = getToggleVal('rembours-sens');
  let valid = true;
  if (!montant || montant <= 0) { document.getElementById('rembours-montant-err').classList.add('show'); valid = false; }
  if (!sens || !calRemboursState.selected) valid = false;
  if (!valid) return;
  if (!verrouAction('remboursement')) return;
  const dateR = calRemboursState.selected.y + '-' + String(calRemboursState.selected.m + 1).padStart(2, '0') + '-01';
  const remboursement = { montant: montant, sens: sens, date_remboursement: dateR, note: document.getElementById('rembours-note').value.trim() || null };
  if (editRemboursementId) {
    // ÉDITION : mise à jour de l'enregistrement existant.
    const { error } = await sb.from('remboursements').update(remboursement).eq('id', editRemboursementId);
    if (error) { libererAction('remboursement'); showToast('Erreur : ' + error.message, 'error'); return; }
    await recalculerCagnotteComplete();
    closeModal('modal-remboursement');
    showToast('✅ Remboursement modifié.', 'success');
    editRemboursementId = null;
    libererAction('remboursement');
    chargerCagnotte();
    return;
  }
  const { error } = await sb.from('remboursements').insert([remboursement]);
  if (error) { libererAction('remboursement'); showToast('Erreur : ' + error.message, 'error'); return; }
  await recalculerCagnotteComplete();
  closeModal('modal-remboursement');
  showToast('✅ Remboursement enregistré.', 'success');

  // ─── Notification e-mail ───
  try {
    notifier('remboursement', {
      montant: remboursement.montant,
      sens: remboursement.sens === 'yassine_vers_marouane' ? 'Yassine \u2192 Marouane' : 'Marouane \u2192 Yassine',
      note: remboursement.note || '', mois: formatMoisAnnee(remboursement.date_remboursement)
    });
  } catch (eNotif) { console.warn('Notification remboursement :', eNotif); }
  libererAction('remboursement');
  chargerCagnotte();
}
function supprimerRemboursement(id) {
  demanderSuppression('Supprimer ce remboursement ? La cagnotte sera réajustée.', () => _doSupprimerRemboursement(id));
}
let editPortVenteId = null;
let editPortModalPaye = null;
function ouvrirEditionPort(venteId) {
  editPortVenteId = venteId;
  const v = (window.__ventesPortCache || []).find(x => x.id === venteId);
  if (!v) { showToast('Vente introuvable.', 'error'); return; }
  document.getElementById('editport-montant').value = (v.frais_port != null ? v.frais_port : '');
  editPortModalPaye = v.port_paye_par || null;
  document.querySelectorAll('#editport-paye .toggle-btn').forEach(b => b.classList.toggle('active', b.getAttribute('data-val') === editPortModalPaye));
  majEditPortModalInfo();
  openModal('modal-edit-port');
}
function setEditPortModalPaye(val) {
  editPortModalPaye = val;
  document.querySelectorAll('#editport-paye .toggle-btn').forEach(b => b.classList.toggle('active', b.getAttribute('data-val') === val));
  majEditPortModalInfo();
}
function majEditPortModalInfo() {
  const info = document.getElementById('editport-info');
  if (!info) return;
  const montant = parseFloat(document.getElementById('editport-montant').value) || 0;
  if (montant <= 0) { info.innerHTML = '<span style="color:var(--text3)">Saisis le montant du port.</span>'; return; }
  if (!editPortModalPaye) { info.innerHTML = '<span style="color:var(--text3)">Indique qui a payé l\'envoi.</span>'; return; }
  const lbl = editPortModalPaye === 'marouane' ? 'Marouane' : 'Yassine';
  info.innerHTML = '<span style="color:var(--green)">✓ Port de ' + montant.toFixed(2) + ' € — revient à ' + lbl + ' (hors CA).</span>';
}
async function enregistrerEditionPort() {
  if (!editPortVenteId) return;
  const montant = parseFloat(document.getElementById('editport-montant').value) || 0;
  if (montant <= 0) { showToast('Montant du port invalide.', 'error'); return; }
  if (!editPortModalPaye) { showToast('Indique qui a payé l\'envoi.', 'error'); return; }
  if (!verrouAction('edit-port')) return;
  const { error } = await sb.from('ventes').update({ frais_port: r2c(montant), port_paye_par: editPortModalPaye }).eq('id', editPortVenteId);
  if (error) { libererAction('edit-port'); showToast('Erreur : ' + error.message, 'error'); return; }
  await recalculerCagnotteComplete();
  closeModal('modal-edit-port');
  showToast('✅ Frais de port modifiés.', 'success');
  editPortVenteId = null;
  libererAction('edit-port');
  chargerCagnotte();
}
function supprimerPort(venteId) {
  demanderSuppression('Supprimer les frais de port de cette vente ? La vente elle-même est conservée, seul le port est retiré.', () => _doSupprimerPort(venteId));
}
async function _doSupprimerPort(venteId) {
  const { error } = await sb.from('ventes').update({ frais_port: null, port_paye_par: null }).eq('id', venteId);
  if (error) { showToast('Erreur : ' + error.message, 'error'); return; }
  await recalculerCagnotteComplete();
  showToast('✅ Frais de port supprimés.', 'success');
  chargerCagnotte();
}

async function _doSupprimerRemboursement(id) {
  const infoR = await (async () => { try {
      const { data } = await sb.from('remboursements').select('montant, sens, date_remboursement, note').eq('id', id).single();
      return data ? { montant: data.montant,
        sens: data.sens === 'yassine_vers_marouane' ? 'Yassine \u2192 Marouane' : 'Marouane \u2192 Yassine',
        note: data.note || '', mois: formatMoisAnnee(data.date_remboursement) } : null;
    } catch (e) { return null; } })();
  const { error } = await sb.from('remboursements').delete().eq('id', id);
  if (error) { showToast('Erreur : ' + error.message, 'error'); return; }
  await recalculerCagnotteComplete();
  showToast('✅ Remboursement supprimé.', 'success');
  if (infoR) notifier('suppr_remboursement', infoR);
  chargerCagnotte();
}

async function enregistrerCharge() {
  const avantEditC = chargeEditId
    ? await snapshotAvantEdition('charges', chargeEditId, ['type_charge', 'montant', 'vendeur', 'date_charge', 'notes'])
    : null;
  const sel = document.getElementById('charge-categorie');
  let categorie = sel.value;
  if (categorie === 'Autre') categorie = document.getElementById('charge-categorie-custom').value.trim();
  const montant = parseFloat(document.getElementById('charge-montant').value);
  const payeur = getToggleVal('charge-payeur');
  let valid = true;
  if (!categorie) { document.getElementById('charge-categorie-err').classList.add('show'); valid = false; }
  if (!montant || montant <= 0) { document.getElementById('charge-montant-err').classList.add('show'); valid = false; }
  if (!calChargeState.selected || !payeur) valid = false;
  if (!valid) return;

  const dateC = calChargeState.selected.y + '-' + String(calChargeState.selected.m + 1).padStart(2, '0') + '-01';
  const charge = {
    type_charge: categorie,
    montant: montant,
    date_charge: dateC,
    frequence: 'ponctuelle',
    vendeur: payeur,
    notes: document.getElementById('charge-note').value.trim() || null
  };

  if (!verrouAction('charge')) return;
  let error;
  if (chargeEditId) {
    ({ error } = await sb.from('charges').update(charge).eq('id', chargeEditId));
  } else {
    ({ error } = await sb.from('charges').insert([charge]));
  }
  if (error) { libererAction('charge'); showToast('Erreur : ' + error.message, 'error'); return; }

  // Les charges impactent la cagnotte → recalcul déterministe
  await recalculerCagnotteComplete();
  closeModal('modal-charge');
  showToast(chargeEditId ? '✅ Charge modifiée.' : '✅ Charge enregistrée.', 'success');

  // ─── Notification e-mail : création OU modification ───
  try {
    const base = {
      categorie: charge.type_charge, montant: charge.montant,
      payeur: charge.vendeur === 'les_deux' ? 'Marouane et Yassine' : charge.vendeur,
      note: charge.notes || '', mois: formatMoisAnnee(charge.date_charge)
    };
    if (chargeEditId) {
      const chg = listerChangements(avantEditC, { type_charge: charge.type_charge, montant: charge.montant,
        vendeur: charge.vendeur, date_charge: charge.date_charge, notes: charge.notes });
      if (chg !== '') notifier('edit_charge', Object.assign(base, { changements: chg }));
    } else {
      notifier('charge', base);
    }
  } catch (eNotif) { console.warn('Notification charge :', eNotif); }
  libererAction('charge');
  chargerCharges();
}

async function ouvrirEditionCharge(id) {
  const { data: c } = await sb.from('charges').select('*').eq('id', id).single();
  if (c && c.shopify_order_id) { showToast('🔒 Cette charge (frais d\'envoi du site) est générée automatiquement et non modifiable.', 'error'); return; }
  if (c && c.charge_recurrente_id) { showToast('🔒 Cette charge est générée par un modèle récurrent. Modifie le modèle dans « Charges récurrentes ».', 'error'); return; }
  if (!c) return;
  chargeEditId = id;
  document.getElementById('charge-modal-title').textContent = '✏️ Modifier la charge';
  // Catégorie : si elle est dans la liste prédéfinie, la sélectionner, sinon "Autre"
  const sel = document.getElementById('charge-categorie');
  const predefinies = Array.from(sel.options).map(o => o.value);
  if (predefinies.includes(c.type_charge)) {
    sel.value = c.type_charge;
    document.getElementById('charge-categorie-custom').style.display = 'none';
  } else {
    sel.value = 'Autre';
    const custom = document.getElementById('charge-categorie-custom');
    custom.style.display = 'block';
    custom.value = c.type_charge;
  }
  document.getElementById('charge-montant').value = c.montant;
  document.getElementById('charge-note').value = c.notes || '';
  document.querySelectorAll('#charge-payeur .toggle-btn').forEach(b => b.classList.remove('active'));
  document.querySelector('#charge-payeur .toggle-btn[data-val="' + c.vendeur + '"]').classList.add('active');
  majChargePayeurHint();
  const d = new Date(c.date_charge);
  calChargeState = { selected: { m: d.getMonth(), y: d.getFullYear() }, year: d.getFullYear() };
  document.getElementById('charge-date-label').textContent = MOIS_COURT[d.getMonth()] + ' ' + d.getFullYear();
  document.getElementById('charge-date-label').style.color = 'var(--text)';
  document.getElementById('charge-cal-wrap').style.display = 'none';
  document.getElementById('charge-categorie-err').classList.remove('show');
  document.getElementById('charge-montant-err').classList.remove('show');
  openModal('modal-charge');
}

function supprimerCharge(id) {
  demanderSuppression('Supprimer cette charge ? La cagnotte sera réajustée.', () => _doSupprimerCharge(id));
}
async function _doSupprimerCharge(id) {
  // Garde-fou : les frais d'envoi du site (avec shopify_order_id) ne se suppriment pas à la main.
  const { data: cCheck } = await sb.from('charges').select('shopify_order_id, charge_recurrente_id').eq('id', id).maybeSingle();
  if (cCheck && cCheck.shopify_order_id) { showToast('🔒 Charge automatique du site — non supprimable manuellement.', 'error'); return; }
  if (cCheck && cCheck.charge_recurrente_id) { showToast('🔒 Charge récurrente — gère-la depuis « Charges récurrentes ».', 'error'); return; }
  const infoS = await libelleAvantSuppression('charges', id);
  const { error } = await sb.from('charges').delete().eq('id', id);
  if (error) { showToast('Erreur : ' + error.message, 'error'); return; }
  await recalculerCagnotteComplete();
  showToast('✅ Charge supprimée.', 'success');
  notifier('suppr_charge', infoS);
  chargerCharges();
}

bulkDeleteHandlers.charges = async function(ids) {
  // Un seul mail récapitulatif : dix suppressions ne doivent pas produire dix e-mails.
  // On ne relève que les lignes qui existent VRAIMENT : une sélection peut contenir
  // un identifiant déjà supprimé, et le mail annoncerait alors un élément fantôme.
  let totalSuppr = 0; const detailsSuppr = []; const idsReels = [];
  try { for (const idc of ids) {
    const { data: exist } = await sb.from('charges').select('id').eq('id', idc).maybeSingle();
    if (!exist) continue;
    idsReels.push(idc);
    const i = await libelleAvantSuppression('charges', idc);
    totalSuppr += (i.montant || 0);
    detailsSuppr.push(i.categorie + ' \u2014 ' + fmtNb(i.montant || 0) + ' \u20ac (' + (i.payeur || '?') + ', ' + (i.mois || '') + ')');
  } } catch (e) {}
  const { error } = await sb.from('charges').delete().in('id', ids);
  if (error) { showToast('Erreur : ' + error.message, 'error'); return ids; }
  await recalculerCagnotteComplete();
  showToast('🗑️ ' + ids.length + ' charge(s) supprimée(s). Cagnotte réajustée.', 'success');
  if (idsReels.length) notifier('suppr_lot', { nature: 'charge(s)', nombre: idsReels.length, montant: totalSuppr, details: detailsSuppr });
  chargerCharges();
  return [];
};

// ═══════════════════════════════════════════════════════════════════
// CHARGES RÉCURRENTES (modèles + génération auto mensuelle)
// ═══════════════════════════════════════════════════════════════════
let allChargesRecurrentes = [];

// Génère les charges manquantes pour tous les modèles actifs, depuis leur
// date de début (ou les derniers mois) jusqu'au mois en cours. Idempotent
// grâce à l'index unique (charge_recurrente_id, mois_genere).
async function genererChargesRecurrentes() {
  try {
    const { data: modeles } = await sb.from('charges_recurrentes').select('*').eq('actif', true);
    if (!modeles || !modeles.length) return 0;

    const maintenant = new Date();
    const moisCourantCle = maintenant.getFullYear() + '-' + String(maintenant.getMonth() + 1).padStart(2, '0');
    let creees = 0;

    for (const m of modeles) {
      // Déterminer la plage de mois à couvrir : de date_debut à mois courant
      // (borné par date_fin si présente).
      const debut = new Date(m.date_debut + 'T00:00:00');
      let curseur = new Date(debut.getFullYear(), debut.getMonth(), 1);
      const finLimite = m.date_fin ? new Date(m.date_fin + 'T00:00:00') : maintenant;
      const stop = new Date(Math.min(maintenant.getTime(), finLimite.getTime()));

      while (curseur <= stop) {
        const cle = curseur.getFullYear() + '-' + String(curseur.getMonth() + 1).padStart(2, '0');
        const jour = Math.min(Math.max(1, m.jour_du_mois || 1), 28);
        const dateCharge = cle + '-' + String(jour).padStart(2, '0');
        // Insertion protégée par l'index unique (charge_recurrente_id, mois_genere).
        const { error } = await sb.from('charges').insert([{
          type_charge: m.type_charge,
          montant: m.montant,
          date_charge: dateCharge,
          vendeur: m.vendeur,
          notes: (m.notes ? m.notes + ' ' : '') + '(charge récurrente)',
          charge_recurrente_id: m.id,
          mois_genere: cle,
        }]);
        if (!error) creees++;
        // Si erreur = doublon (déjà généré ce mois), on ignore silencieusement.
        curseur = new Date(curseur.getFullYear(), curseur.getMonth() + 1, 1);
      }
    }
    if (creees > 0) {
      await recalculerCagnotteComplete();
      console.log('🔁 Charges récurrentes générées :', creees);
    }
    return creees;
  } catch (e) {
    console.warn('genererChargesRecurrentes', e);
    return 0;
  }
}

async function chargerChargesRecurrentes() {
  const cont = document.getElementById('charges-recurrentes-content');
  if (!cont) return;
  try {
  const { data, error } = await sb.from('charges_recurrentes').select('*').order('created_at', { ascending: false });
  if (error) { cont.innerHTML = '<div class="err-box">Erreur : ' + escapeHtml(error.message) + '</div>'; return; }
  allChargesRecurrentes = data || [];
  if (!allChargesRecurrentes.length) {
    cont.innerHTML = '<div style="font-size:13px;color:var(--text3);padding:8px 0">Aucune charge récurrente. Clique « ＋ Ajouter une charge récurrente ».</div>';
    return;
  }
  // Helper LOCAL pour le libellé du payeur (payeurLabel global n'existe pas dans ce scope).
  const payeurBadge = v => v === 'marouane' ? '<span class="badge badge-marouane">Marouane</span>'
    : v === 'yassine' ? '<span class="badge badge-yassine">Yassine</span>'
    : '<span class="badge badge-commun">Marouane et Yassine</span>';
  const moisLabel = d => { const [a, mo] = d.split('-'); return (MOIS_COURT[parseInt(mo) - 1] || mo) + ' ' + a; };
  cont.innerHTML = '<div class="table-wrap"><table><thead><tr>' +
    '<th>Catégorie</th><th>Montant</th><th>Jour</th><th>Payeur</th><th>Période</th><th>Statut</th><th></th>' +
    '</tr></thead><tbody>' +
    allChargesRecurrentes.map(m => {
      const periode = moisLabel(m.date_debut.slice(0, 7)) + (m.date_fin ? ' → ' + moisLabel(m.date_fin.slice(0, 7)) : ' → …');
      return '<tr' + (m.actif ? '' : ' style="opacity:.5"') + '>' +
        '<td><strong>' + escapeHtml(m.type_charge) + '</strong>' + (m.notes ? '<br><span style="font-size:11px;color:var(--text3)">' + escapeHtml(m.notes) + '</span>' : '') + '</td>' +
        '<td style="color:var(--red);font-weight:600">-' + Number(m.montant).toFixed(2) + ' €</td>' +
        '<td>le ' + m.jour_du_mois + '</td>' +
        '<td>' + payeurBadge(m.vendeur) + '</td>' +
        '<td style="font-size:12px">' + periode + '</td>' +
        '<td>' + (m.actif ? '<span class="badge badge-commun">Actif</span>' : '<span class="badge" style="background:var(--bg3);color:var(--text3)">En pause</span>') + '</td>' +
        '<td><div class="action-btns">' +
          '<button class="btn btn-ghost btn-sm" onclick="basculerChargeRecurrente(\'' + m.id + '\')" title="' + (m.actif ? 'Mettre en pause' : 'Réactiver') + '">' + (m.actif ? '⏸️' : '▶️') + '</button>' +
          '<button class="btn btn-ghost btn-sm" onclick="ouvrirEditChargeRecurrente(\'' + m.id + '\')" title="Éditer">✏️</button>' +
          '<button class="btn btn-ghost btn-sm" onclick="supprimerChargeRecurrente(\'' + m.id + '\')" title="Supprimer">🗑️</button>' +
        '</div></td>' +
      '</tr>';
    }).join('') + '</tbody></table></div>';
  } catch (e) {
    console.error('chargerChargesRecurrentes', e);
    cont.innerHTML = '<div class="err-box">Erreur d\'affichage : ' + escapeHtml(String(e && e.message || e)) + '</div>';
  }
}

function onChargeRecCategorieChange() {
  const sel = document.getElementById('charge-rec-categorie');
  const custom = document.getElementById('charge-rec-categorie-custom');
  custom.style.display = sel.value === 'Autre' ? 'block' : 'none';
}

function ouvrirEditChargeRecurrente(id) {
  const m = id ? allChargesRecurrentes.find(x => x.id === id) : null;
  document.getElementById('charge-rec-modal-title').textContent = m ? '🔁 Modifier la charge récurrente' : '🔁 Ajouter une charge récurrente';
  document.getElementById('charge-rec-id').value = m ? m.id : '';
  // Catégorie
  const cats = ['Shopify', 'Publicité', 'Abonnement', 'Matériel'];
  const sel = document.getElementById('charge-rec-categorie');
  const custom = document.getElementById('charge-rec-categorie-custom');
  if (m && !cats.includes(m.type_charge)) {
    sel.value = 'Autre'; custom.style.display = 'block'; custom.value = m.type_charge;
  } else {
    sel.value = m ? m.type_charge : ''; custom.style.display = 'none'; custom.value = '';
  }
  document.getElementById('charge-rec-montant').value = m ? m.montant : '';
  document.getElementById('charge-rec-jour').value = m ? m.jour_du_mois : 1;
  document.getElementById('charge-rec-debut').value = m ? m.date_debut.slice(0, 7) : (new Date().toISOString().slice(0, 7));
  document.getElementById('charge-rec-fin').value = m && m.date_fin ? m.date_fin.slice(0, 7) : '';
  document.getElementById('charge-rec-note').value = m ? (m.notes || '') : '';
  // Payeur
  ['charge-rec-categorie-err', 'charge-rec-montant-err', 'charge-rec-jour-err', 'charge-rec-debut-err'].forEach(i => { const e = document.getElementById(i); if (e) e.classList.remove('show'); });
  const payeur = m ? m.vendeur : 'les_deux';
  document.querySelectorAll('#charge-rec-payeur .toggle-btn').forEach(b => b.classList.toggle('active', b.dataset.val === payeur));
  openModal('modal-charge-recurrente');
}

async function enregistrerChargeRecurrente() {
  const sel = document.getElementById('charge-rec-categorie').value;
  const custom = document.getElementById('charge-rec-categorie-custom').value.trim();
  const categorie = sel === 'Autre' ? custom : sel;
  const montant = parseFloat(document.getElementById('charge-rec-montant').value);
  const jour = parseInt(document.getElementById('charge-rec-jour').value);
  const debut = document.getElementById('charge-rec-debut').value;
  const fin = document.getElementById('charge-rec-fin').value;
  const note = document.getElementById('charge-rec-note').value.trim();
  const payeurBtn = document.querySelector('#charge-rec-payeur .toggle-btn.active');
  const payeur = payeurBtn ? payeurBtn.dataset.val : 'les_deux';

  let ok = true;
  if (!categorie) { document.getElementById('charge-rec-categorie-err').classList.add('show'); ok = false; }
  if (isNaN(montant) || montant < 0) { document.getElementById('charge-rec-montant-err').classList.add('show'); ok = false; }
  if (isNaN(jour) || jour < 1 || jour > 28) { document.getElementById('charge-rec-jour-err').classList.add('show'); ok = false; }
  if (!debut) { document.getElementById('charge-rec-debut-err').classList.add('show'); ok = false; }
  if (!ok) return;

  const payload = {
    type_charge: categorie, montant: montant, jour_du_mois: jour, vendeur: payeur,
    notes: note || null, date_debut: debut + '-01', date_fin: fin ? fin + '-01' : null,
  };
  const id = document.getElementById('charge-rec-id').value;
  if (!verrouAction('charge-recurrente')) return;
  let error;
  if (id) { ({ error } = await sb.from('charges_recurrentes').update(payload).eq('id', id)); }
  else { ({ error } = await sb.from('charges_recurrentes').insert([payload])); }
  if (error) { libererAction('charge-recurrente'); showToast('Erreur : ' + error.message, 'error'); return; }
  closeModal('modal-charge-recurrente');
  showToast(id ? '✅ Charge récurrente mise à jour.' : '✅ Charge récurrente ajoutée.', 'success');
  // Générer immédiatement les charges dues + rafraîchir.
  await genererChargesRecurrentes();
  await chargerChargesRecurrentes();
  libererAction('charge-recurrente');
  chargerCharges();
}

async function basculerChargeRecurrente(id) {
  const m = allChargesRecurrentes.find(x => x.id === id);
  if (!m) return;
  const { error } = await sb.from('charges_recurrentes').update({ actif: !m.actif }).eq('id', id);
  if (error) { showToast('Erreur : ' + error.message, 'error'); return; }
  showToast(m.actif ? 'Charge récurrente mise en pause.' : 'Charge récurrente réactivée.', 'success');
  if (!m.actif) await genererChargesRecurrentes(); // réactivation -> rattrapage
  await chargerChargesRecurrentes();
  chargerCharges();
}

async function supprimerChargeRecurrente(id) {
  const m = allChargesRecurrentes.find(x => x.id === id);
  if (!m) return;
  if (!confirm('Supprimer la charge récurrente « ' + m.type_charge + ' » ?\n\nLes charges déjà générées les mois passés sont conservées ; seules les futures ne seront plus créées.')) return;
  const { error } = await sb.from('charges_recurrentes').delete().eq('id', id);
  if (error) { showToast('Erreur : ' + error.message, 'error'); return; }
  showToast('Charge récurrente supprimée.', 'success');
  chargerChargesRecurrentes();
}

async function chargerCharges() {
  document.getElementById('charges-content').innerHTML = '<div class="loading"><div class="spinner"></div> Chargement...</div>';
  let data;
  try { data = await selectTout('charges', '*', { col: 'date_charge', asc: false }, null, true); }
  catch (error) { document.getElementById('charges-content').innerHTML = '<div class="err-box">Erreur : ' + error.message + '</div>'; return; }
  const charges = data || [];

  // Résumé : total, ce mois-ci, répartition par payeur
  const total = charges.reduce((s, c) => s + (c.montant || 0), 0);
  const now = new Date();
  const moisCourant = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0');
  const totalMois = charges.filter(c => (c.date_charge || '').startsWith(moisCourant)).reduce((s, c) => s + (c.montant || 0), 0);
  const carte = (label, val, couleur) =>
    '<div class="kpi-card"><div class="kpi-label">' + label + '</div>' +
    '<div class="kpi-value kpi-value-sm" style="color:' + (couleur || 'var(--text)') + '">' + val + '</div></div>';
  document.getElementById('charges-resume').innerHTML =
    '<div class="kpi-row" style="width:100%">' +
    carte('Total des charges', total.toFixed(2) + ' €', 'var(--red)') +
    carte('Ce mois-ci', totalMois.toFixed(2) + ' €') +
    carte('Nombre', String(charges.length)) +
    '</div>';

  document.getElementById('charges-count').textContent = charges.length ? '(' + charges.length + ')' : '';

  if (!charges.length) {
    document.getElementById('charges-content').innerHTML = '<div class="info-box">Aucune charge enregistrée. Clique sur « Ajouter une charge » pour commencer.</div>';
    return;
  }

  if (!allChargesInit) { columnFilterConfig.charges = {
    source: () => allCharges,
    refilter: () => filtrerCharges(),
    columns: [
      { key: 'type_charge', label: 'Catégorie', type: 'select', getValue: c => c.type_charge, formatLabel: v => v },
      { key: 'vendeur', label: 'Payé par', type: 'select', getValue: c => c.vendeur, formatLabel: v => v === 'marouane' ? 'Marouane' : v === 'yassine' ? 'Yassine' : 'Marouane et Yassine' },
      { key: 'montant', label: 'Montant', type: 'range', getValue: c => c.montant }
    ]
  }; allChargesInit = true; }
  allCharges = charges;
  peuplerSelecteurMoisCharges(charges);
  filtrerCharges();
}

// Mois sélectionné dans la liste des charges, "YYYY-MM". null = mois courant par défaut.
let chargesMoisSelectionne = null;

function peuplerSelecteurMoisCharges(charges) {
  const select = document.getElementById('charges-mois-select');
  if (!select) return;
  const moisPresents = Array.from(new Set(charges.map(c => cleMois(c.date_charge)))).sort().reverse();
  const now = new Date();
  const moisCourant = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0');
  if (chargesMoisSelectionne === null) chargesMoisSelectionne = moisCourant;
  const listeMois = moisPresents.slice();
  if (!listeMois.includes(moisCourant)) listeMois.unshift(moisCourant);
  if (!listeMois.includes(chargesMoisSelectionne)) chargesMoisSelectionne = moisCourant;
  select.innerHTML = listeMois.map(cle => {
    const nb = charges.filter(c => cleMois(c.date_charge) === cle).length;
    const sel = cle === chargesMoisSelectionne ? ' selected' : '';
    return '<option value="' + cle + '"' + sel + '>' + libelleMois(cle) + ' (' + nb + ')</option>';
  }).join('');
}

function changerMoisCharges(cle) {
  chargesMoisSelectionne = cle;
  filtrerCharges();
}

function filtrerCharges() {
  let result = applyColumnFilters('charges', allCharges);
  if (chargesMoisSelectionne) {
    result = result.filter(c => cleMois(c.date_charge) === chargesMoisSelectionne);
  }
  renderChargesTable(result);
  renderActiveFiltersBar('charges');
}

function renderChargesTable(list) {
  bulkCurrentList.charges = list;
  bulkPurgerSelection('charges');
  const payeurLabel = v => v === 'marouane' ? '<span class="badge badge-marouane">Marouane</span>'
    : v === 'yassine' ? '<span class="badge badge-yassine">Yassine</span>'
    : '<span class="badge badge-commun">Marouane et Yassine</span>';
  // Compteur = charges affichées (mois sélectionné).
  const cntC = document.getElementById('charges-count');
  if (cntC) cntC.textContent = list.length ? '(' + list.length + ')' : '';
  if (!list.length) { document.getElementById('charges-content').innerHTML = '<div class="info-box">Aucune charge ce mois-ci.</div>'; return; }
  document.getElementById('charges-content').innerHTML =
    '<div class="table-wrap"><table>' +
    '<thead><tr><th class="select-col"><input type="checkbox" class="select-checkbox" onchange="bulkToggleAll(\'charges\', this.checked)"></th><th>Date</th><th class="filterable">Catégorie' + colFilterIcon('charges', 'type_charge') + '</th><th>Note</th><th class="filterable">Montant' + colFilterIcon('charges', 'montant') + '</th><th class="filterable">Payé par' + colFilterIcon('charges', 'vendeur') + '</th><th></th></tr></thead><tbody>' +
    list.map(c => {
      const dt = new Date(c.date_charge);
      const dateLabel = MOIS_COURT[dt.getMonth()] + ' ' + dt.getFullYear();
      const checked = bulkSelection.charges && bulkSelection.charges.has(c.id) ? 'checked' : '';
      return '<tr>' +
        '<td class="select-col">' + ((c.shopify_order_id || c.charge_recurrente_id) ? '' : '<input type="checkbox" class="select-checkbox" data-contexte="charges" ' + checked + ' onchange="bulkToggle(\'charges\',\'' + c.id + '\',this.checked)">') + '</td>' +
        '<td>' + dateLabel + '</td>' +
        '<td><strong>' + escapeHtml(c.type_charge) + '</strong></td>' +
        '<td style="color:var(--text3)">' + escapeHtml(c.notes || '—') + '</td>' +
        '<td style="color:' + (c.montant < 0 ? 'var(--green)' : 'var(--red)') + ';font-weight:600">' +
          (c.montant < 0 ? '+' + Math.abs(c.montant).toFixed(2) : '-' + c.montant.toFixed(2)) + ' €</td>' +
        '<td>' + payeurLabel(c.vendeur) + '</td>' +
        '<td>' + ((c.shopify_order_id || c.charge_recurrente_id)
          ? '<div class="action-btns"><span title="' + (c.shopify_order_id ? 'Frais d\'envoi automatique du site' : 'Charge récurrente automatique') + ' — non modifiable" style="opacity:.6">🔒</span></div>'
          : '<div class="action-btns"><button class="btn btn-ghost btn-sm" onclick="ouvrirEditionCharge(\'' + c.id + '\')" title="Éditer">✏️</button><button class="btn btn-ghost btn-sm" onclick="supprimerCharge(\'' + c.id + '\')" title="Supprimer">🗑️</button></div>') + '</td>' +
      '</tr>';
    }).join('') +
    '</tbody></table></div>';
}

async function chargerCagnotte() {
  document.getElementById('cagnotte-content').innerHTML = '<div class="loading"><div class="spinner"></div> Chargement...</div>';
  // Recalculer la cagnotte AVANT de l'afficher : garantit que les ventes du site
  // arrivées par webhook (pendant que l'app était fermée ou sur un autre onglet)
  // sont bien intégrées à l'historique, même sans rafraîchissement temps réel.
  try { await recalculerCagnotteComplete(); } catch (e) { console.warn('Recalcul cagnotte à l\'ouverture', e); }
  let data;
  try { data = await selectTout('cagnotte'); }
  catch (error) { document.getElementById('cagnotte-content').innerHTML = '<div class="err-box">Erreur : ' + (error && error.message || error) + '</div>'; return; }
  // Cache des remboursements + ventes-avec-port (pour l'édition des mouvements cagnotte).
  try { window.__remboursementsCache = await selectTout('remboursements'); } catch (e) { window.__remboursementsCache = []; }
  try { window.__ventesPortCache = await selectTout('ventes', 'id, frais_port, port_paye_par, vendeur, prix_unitaire, quantite'); } catch (e) { window.__ventesPortCache = []; }
  // Trier par ordre chronologique réel (date du mouvement, puis created_at) — le plus récent en premier.
  // On NE se fie PAS au seul created_at car tous les mouvements sont réinsérés en bloc lors du
  // recalcul déterministe et peuvent partager un created_at quasi identique.
  const mvts = (data || []).slice().sort((a, b) => {
    const d = (b.date_mouvement || '').localeCompare(a.date_mouvement || '');
    if (d !== 0) return d;
    return (b.created_at || '').localeCompare(a.created_at || '');
  });

  // Le solde courant = solde cumulé total = somme de tous les impacts (robuste, indépendant du tri).
  const soldeCourant = Math.round((mvts.reduce((s, m) => s + (m.impact || 0), 0)) * 100) / 100;
  soldeCagnotteCourant = soldeCourant;
  renderSoldeCagnotte(soldeCourant);

  document.getElementById('cagnotte-count').textContent = mvts.length + ' mouvement' + (mvts.length > 1 ? 's' : '');

  if (!mvts.length) {
    document.getElementById('cagnotte-content').innerHTML = '<div class="empty"><div class="empty-icon">💰</div><p>Aucun mouvement pour le moment.</p></div>';
    return;
  }

  // Récupérer le vendeur réel de chaque mouvement. Les achats pointent vers la table achats,
  // les ventes vers la table ventes — il faut interroger les deux séparément.
  const idsAchats = mvts.filter(m => m.reference_type === 'achat').map(m => m.reference_id);
  const idsVentes = mvts.filter(m => m.reference_type === 'vente').map(m => m.reference_id);
  let vendeurParAchatId = {};
  if (idsAchats.length) {
    const { data: achatsSource } = await sb.from('achats').select('id, vendeur').in('id', idsAchats);
    (achatsSource || []).forEach(a => { vendeurParAchatId[a.id] = a.vendeur; });
  }
  let vendeurParVenteId = {};
  if (idsVentes.length) {
    const { data: ventesSource } = await sb.from('ventes').select('id, vendeur').in('id', idsVentes);
    (ventesSource || []).forEach(v => { vendeurParVenteId[v.id] = v.vendeur; });
  }
  const prenom = v => v === 'marouane' ? 'Marouane' : v === 'yassine' ? 'Yassine' : '—';

  // Recalculer le solde cumulé dans l'ordre chronologique ASCENDANT pour un affichage cohérent,
  // puis afficher du plus récent au plus ancien. On n'utilise pas le solde_apres stocké car
  // l'ordre d'insertion en bloc peut ne pas refléter l'ordre des dates.
  const mvtsAsc = mvts.slice().reverse(); // mvts est trié DESC → asc
  let cumul = 0;
  const soldeParId = {};
  mvtsAsc.forEach(m => { cumul = Math.round((cumul + (m.impact || 0)) * 100) / 100; soldeParId[m.id] = cumul; });

  // Enrichir chaque mouvement (solde cumulé + vendeur résolu) puis filtrer l'affichage.
  mvts.forEach(m => {
    m._soldeApres = soldeParId[m.id] !== undefined ? soldeParId[m.id] : m.solde_apres;
    m._quiVal = m.vendeur || (m.reference_type === 'vente' ? vendeurParVenteId[m.reference_id] : vendeurParAchatId[m.reference_id]) || null;
  });
  allCagnotteMvts = mvts;

  // Peupler le sélecteur de mois (clés "YYYY-MM") à partir des mouvements présents.
  // Par défaut, on sélectionne le MOIS EN COURS (ou le plus récent disponible si le
  // mois courant n'a aucun mouvement).
  peuplerSelecteurMoisCagnotte(mvts);

  if (!allCagnotteInit) {
    columnFilterConfig.cagnotte = {
      source: () => allCagnotteMvts,
      refilter: () => filtrerCagnotte(),
      columns: [
        { key: 'type_mouvement', label: 'Type', type: 'select', getValue: m => m.type_mouvement, formatLabel: v => v === 'achat' ? 'Achat' : v === 'vente' ? 'Vente' : v === 'remboursement' ? 'Remboursement' : v === 'charge' ? 'Charge' : v },
        { key: 'qui', label: 'Qui', type: 'select', getValue: m => m._quiVal, formatLabel: v => v === 'marouane' ? 'Marouane' : v === 'yassine' ? 'Yassine' : v }
      ]
    };
    allCagnotteInit = true;
  }
  filtrerCagnotte();
}

// Mois actuellement sélectionné dans l'historique cagnotte, au format "YYYY-MM".
// null = pas encore initialisé (on prendra le mois courant).
let cagnotteMoisSelectionne = null;

function cleMois(dateStr) {
  // Retourne "YYYY-MM" à partir d'une date de mouvement.
  const dt = new Date(dateStr);
  return dt.getFullYear() + '-' + String(dt.getMonth() + 1).padStart(2, '0');
}

function libelleMois(cle) {
  const [y, m] = cle.split('-').map(Number);
  return MOIS_COURT[m - 1] + ' ' + y;
}

function peuplerSelecteurMoisCagnotte(mvts) {
  const select = document.getElementById('cagnotte-mois-select');
  if (!select) return;

  // Ensemble des mois présents dans les mouvements, triés du plus récent au plus ancien.
  const moisPresents = Array.from(new Set(mvts.map(m => cleMois(m.date_mouvement)))).sort().reverse();

  // Clé du mois EN COURS.
  const now = new Date();
  const moisCourant = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0');

  // Au premier chargement, on force le mois courant. Si le mois courant n'a aucun
  // mouvement, on l'ajoute quand même en tête pour rester "sur le mois en cours".
  if (cagnotteMoisSelectionne === null) {
    cagnotteMoisSelectionne = moisCourant;
  }
  const listeMois = moisPresents.slice();
  if (!listeMois.includes(moisCourant)) listeMois.unshift(moisCourant);
  // Si le mois sélectionné n'existe plus dans la liste (ex. après suppression), replier sur le courant.
  if (!listeMois.includes(cagnotteMoisSelectionne)) cagnotteMoisSelectionne = moisCourant;

  select.innerHTML = listeMois.map(cle => {
    const nb = mvts.filter(m => cleMois(m.date_mouvement) === cle).length;
    const sel = cle === cagnotteMoisSelectionne ? ' selected' : '';
    return '<option value="' + cle + '"' + sel + '>' + libelleMois(cle) + ' (' + nb + ')</option>';
  }).join('');
}

function changerMoisCagnotte(cle) {
  cagnotteMoisSelectionne = cle;
  filtrerCagnotte();
}

function filtrerCagnotte() {
  let result = applyColumnFilters('cagnotte', allCagnotteMvts);
  // Filtrer sur le mois sélectionné (le solde "après" reste le cumul global, calculé en amont).
  if (cagnotteMoisSelectionne) {
    result = result.filter(m => cleMois(m.date_mouvement) === cagnotteMoisSelectionne);
  }
  renderCagnotteTable(result);
  renderActiveFiltersBar('cagnotte');
}

function renderCagnotteTable(list) {
  const prenom = v => v === 'marouane' ? 'Marouane' : v === 'yassine' ? 'Yassine' : '—';
  // Le compteur reflète le nombre de mouvements AFFICHÉS (mois sélectionné).
  const cnt = document.getElementById('cagnotte-count');
  if (cnt) cnt.textContent = list.length + ' mouvement' + (list.length > 1 ? 's' : '');
  if (!list.length) { document.getElementById('cagnotte-content').innerHTML = '<div class="info-box">Aucun mouvement ce mois-ci.</div>'; return; }
  document.getElementById('cagnotte-content').innerHTML =
    '<div class="table-wrap"><table>' +
    '<thead><tr><th>Date</th><th class="filterable">Type' + colFilterIcon('cagnotte', 'type_mouvement') + '</th><th>Description</th><th class="filterable">Qui' + colFilterIcon('cagnotte', 'qui') + '</th><th>Montant total</th><th>Impact</th><th>Solde après</th><th></th></tr></thead><tbody>' +
    list.map(m => {
      const dt = new Date(m.date_mouvement);
      const dateLabel = MOIS_COURT[dt.getMonth()] + ' ' + dt.getFullYear();
      const typeLabel = m.type_mouvement === 'achat' ? 'Achat' : m.type_mouvement === 'vente' ? 'Vente' : m.type_mouvement === 'remboursement' ? '\ud83e\udd1d Remb.' : m.type_mouvement === 'charge' ? '\ud83d\udcb8 Charge' : m.type_mouvement;
      const impactSigne = m.impact > 0 ? '+' : '';
      const impactColor = m.impact > 0 ? 'var(--text)' : 'var(--red)';
      const qui = prenom(m._quiVal);
      const soldeApres = m._soldeApres;
      let action = '';
      const estPort = (m.description || '').indexOf('\ud83d\udce6 Frais de port') === 0; // commence par 📦 Frais de port
      if (m.reference_type === 'remboursement') {
        action = '<button class="btn btn-ghost btn-sm" onclick="ouvrirRemboursement(\'' + m.reference_id + '\')" title="Modifier">\u270f\ufe0f</button>'
               + '<button class="btn btn-ghost btn-sm" onclick="supprimerRemboursement(\'' + m.reference_id + '\')" title="Supprimer">\ud83d\uddd1\ufe0f</button>';
      } else if (estPort) {
        action = '<button class="btn btn-ghost btn-sm" onclick="ouvrirEditionPort(\'' + m.reference_id + '\')" title="Modifier le port">\u270f\ufe0f</button>'
               + '<button class="btn btn-ghost btn-sm" onclick="supprimerPort(\'' + m.reference_id + '\')" title="Supprimer le port">\ud83d\uddd1\ufe0f</button>';
      }
      return '<tr>' +
        '<td>' + dateLabel + '</td>' +
        '<td>' + typeLabel + '</td>' +
        '<td>' + escapeHtml(m.description || '—') + '</td>' +
        '<td>' + qui + '</td>' +
        '<td>' + m.montant_total.toFixed(2) + ' €</td>' +
        '<td style="color:' + impactColor + ';font-weight:600">' + impactSigne + m.impact.toFixed(2) + ' €</td>' +
        '<td>' + soldeApres.toFixed(2) + ' €</td>' +
        '<td>' + action + '</td>' +
      '</tr>';
    }).join('') +
    '</tbody></table></div>';
}

function renderSoldeCagnotte(solde) {
  const wrap = document.getElementById('cagnotte-solde-wrap');
  const montantAbs = Math.abs(solde).toFixed(2) + ' €';

  if (Math.abs(solde) < 0.01) {
    wrap.innerHTML =
      '<div style="color:var(--text3);font-size:12px;text-transform:uppercase;letter-spacing:.5px;margin-bottom:8px">Solde de la cagnotte</div>' +
      '<div style="color:var(--text);font-size:24px;font-weight:700">✅ Compte équilibré</div>';
    return;
  }

  // Positif -> Marouane doit à Yassine ; négatif -> Yassine doit à Marouane.
  const debiteur = solde > 0 ? 'Marouane' : 'Yassine';
  const crediteur = solde > 0 ? 'Yassine' : 'Marouane';

  wrap.innerHTML =
    '<div style="color:var(--text3);font-size:12px;text-transform:uppercase;letter-spacing:.5px;margin-bottom:8px">Solde de la cagnotte</div>' +
    '<div style="color:var(--gold);font-size:28px;font-weight:700;margin-bottom:6px">' + montantAbs + '</div>' +
    '<div style="color:var(--text2);font-size:14px">' + debiteur + ' doit cette somme à ' + crediteur + '</div>';
}

// ══════════════════════════════════════════
// VENTE — saisie des ventes manuelles (hors Shopify et via site)
// ══════════════════════════════════════════

let selectedParfumVente = null;
let enchainerApresVente = false; // si true : après enregistrement, on reste sur la même réf
let allParfumsVente = [];
let stockVente = 0;
let calVenteState = { selected: null, month: new Date().getMonth(), year: new Date().getFullYear() };

function initVente() {
  resetVenteStep1();
}

// Helpers globaux pour l'affichage transporteurs.
function escapeHtml(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
function fmtPrixG(n) { return (n != null && !isNaN(n)) ? Number(n).toFixed(2).replace('.', ',') + ' €' : '—'; }

// ═══ SOUS-ONGLETS CHARGES / TRANSPORTEURS ═══
let chargesTabActif = 'charges';
function switchChargesTab(tab) {
  chargesTabActif = tab;
  const estCharges = tab === 'charges';
  document.getElementById('charges-vue').style.display = estCharges ? 'block' : 'none';
  document.getElementById('transporteurs-vue').style.display = estCharges ? 'none' : 'block';
  document.getElementById('subtab-charges').classList.toggle('active', estCharges);
  document.getElementById('subtab-transporteurs').classList.toggle('active', !estCharges);
  if (estCharges) { chargerCharges(); chargerChargesRecurrentes(); }
  else chargerTransporteurs();
}

// ═══ TRANSPORTEURS : chargement + affichage ═══
let allTransporteurs = [];

async function chargerTransporteurs() {
  document.getElementById('transporteurs-content').innerHTML = '<div class="loading"><div class="spinner"></div> Chargement...</div>';
  const { data, error } = await sb.from('transporteurs').select('*').order('ordre').order('nom');
  if (error) { document.getElementById('transporteurs-content').innerHTML = '<div class="err-box">Erreur : ' + error.message + '</div>'; return; }
  allTransporteurs = data || [];
  // Premier lancement : si aucun transporteur, proposer le pré-remplissage.
  if (!allTransporteurs.length) {
    document.getElementById('transporteurs-content').innerHTML =
      '<div class="info-box">Aucun transporteur configuré. ' +
      '<button class="btn btn-gold btn-sm" style="margin-left:8px" onclick="preremplirTransporteurs()">Pré-remplir avec les tarifs publics 2026</button> ' +
      'ou <button class="btn btn-ghost btn-sm" onclick="ouvrirEditTransporteur()">ajouter le mien</button></div>';
    return;
  }
  renderTransporteurs();
}

function renderTransporteurs() {
  const fmtG = g => g >= 1000 ? (g / 1000).toString().replace('.', ',') + ' kg' : g + ' g';
  const grilleHtml = (tranches, titre) => {
    if (!tranches || !tranches.length) return '<div style="font-size:12px;color:var(--text3)">' + titre + ' : non renseigné</div>';
    return '<div style="flex:1;min-width:140px">' +
      '<div style="font-size:12px;color:var(--text3);margin-bottom:6px">' + titre + '</div>' +
      '<table style="width:100%;font-size:13px;border-collapse:collapse">' +
      tranches.map(t => '<tr><td style="padding:3px 0;color:var(--text2)">jusqu\'à ' + fmtG(t.max_g) + '</td>' +
        '<td style="text-align:right;color:var(--text)">' + fmtPrixG(t.prix) + '</td></tr>').join('') +
      '</table></div>';
  };
  document.getElementById('transporteurs-content').innerHTML = allTransporteurs.map(tr => {
    const g = tr.grille || {};
    return '<div class="card" style="background:var(--bg2);margin-bottom:12px">' +
      '<div style="display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:8px;margin-bottom:12px">' +
        '<div style="display:flex;align-items:center;gap:8px">' +
          '<span style="font-size:15px;font-weight:600">' + escapeHtml(tr.nom) + '</span>' +
          (tr.mode_livraison ? '<span class="badge badge-commun">' + escapeHtml(tr.mode_livraison) + '</span>' : '') +
          (tr.actif ? '' : '<span class="badge" style="background:var(--red2);color:var(--red)">inactif</span>') +
        '</div>' +
        '<div style="display:flex;gap:4px">' +
          '<button class="btn btn-ghost btn-sm" onclick="ouvrirEditTransporteur(\'' + tr.id + '\')" title="Modifier">✏️</button>' +
          '<button class="btn btn-ghost btn-sm" onclick="supprimerTransporteur(\'' + tr.id + '\')" title="Supprimer">🗑️</button>' +
        '</div>' +
      '</div>' +
      (tr.alias_shopify ? '<div style="font-size:12px;color:var(--text3);margin-bottom:10px">Correspondance Shopify : ' + escapeHtml(tr.alias_shopify) + '</div>' : '') +
      '<div style="display:flex;gap:20px;flex-wrap:wrap">' +
        grilleHtml(g.france, 'France') +
        grilleHtml(g.euro, 'Zone Euro') +
      '</div>' +
    '</div>';
  }).join('');
}

// ═══ PRÉ-REMPLISSAGE : tarifs publics 2026 (à ajuster par l'utilisateur) ═══
async function preremplirTransporteurs() {
  const presets = [
    {
      nom: 'Colissimo', mode_livraison: 'Domicile', alias_shopify: 'Colissimo|La Poste',
      ordre: 1,
      grille: {
        france: [
          { max_g: 250, prix: 5.49 }, { max_g: 500, prix: 7.59 }, { max_g: 750, prix: 9.29 },
          { max_g: 1000, prix: 9.59 }, { max_g: 2000, prix: 11.19 }, { max_g: 5000, prix: 17.39 },
          { max_g: 10000, prix: 25.29 }
        ],
        euro: [
          { max_g: 500, prix: 14.99 }, { max_g: 1000, prix: 19.39 }, { max_g: 2000, prix: 22.19 },
          { max_g: 5000, prix: 28.59 }, { max_g: 10000, prix: 46.99 }
        ]
      }
    },
    {
      nom: 'Mondial Relay', mode_livraison: 'Point Relais', alias_shopify: 'Mondial Relay|Point Relais',
      ordre: 2,
      grille: {
        france: [
          { max_g: 500, prix: 4.40 }, { max_g: 1000, prix: 4.90 }, { max_g: 2000, prix: 6.50 },
          { max_g: 3000, prix: 7.05 }, { max_g: 4000, prix: 7.30 }, { max_g: 5000, prix: 11.50 }
        ],
        euro: [
          { max_g: 500, prix: 5.55 }, { max_g: 1000, prix: 6.05 }, { max_g: 2000, prix: 7.05 },
          { max_g: 3000, prix: 8.30 }, { max_g: 5000, prix: 11.90 }
        ]
      }
    },
    {
      nom: 'Chronopost', mode_livraison: 'Shop2Shop (relais)', alias_shopify: 'Chronopost|Shop2Shop',
      ordre: 3,
      grille: {
        france: [
          { max_g: 1000, prix: 4.50 }, { max_g: 3000, prix: 6.50 }, { max_g: 10000, prix: 10.50 },
          { max_g: 20000, prix: 17.50 }
        ],
        euro: []
      }
    }
  ];
  const { error } = await sb.from('transporteurs').insert(presets);
  if (error) { showToast('Erreur pré-remplissage : ' + error.message, 'error'); return; }
  showToast('✅ Transporteurs pré-remplis (tarifs publics 2026). Ajuste-les avec tes tarifs.', 'success');
  chargerTransporteurs();
}

async function supprimerTransporteur(id) {
  const tr = allTransporteurs.find(x => x.id === id);
  if (!tr) return;
  if (!confirm('Supprimer le transporteur « ' + tr.nom + ' » ?')) return;
  const { error } = await sb.from('transporteurs').delete().eq('id', id);
  if (error) { showToast('Erreur : ' + error.message, 'error'); return; }
  showToast('Transporteur supprimé.', 'success');
  chargerTransporteurs();
}

// ═══ ÉDITION D'UN TRANSPORTEUR (modale) ═══
// État de travail des tranches en cours d'édition (avant enregistrement).
let trancheDraft = { france: [], euro: [] };

function ouvrirEditTransporteur(id) {
  const tr = id ? allTransporteurs.find(x => x.id === id) : null;
  document.getElementById('transporteur-modal-title').textContent = tr ? '🚚 Modifier le transporteur' : '🚚 Ajouter un transporteur';
  document.getElementById('transporteur-id').value = tr ? tr.id : '';
  document.getElementById('transporteur-nom').value = tr ? (tr.nom || '') : '';
  document.getElementById('transporteur-mode').value = tr ? (tr.mode_livraison || '') : '';
  document.getElementById('transporteur-alias').value = tr ? (tr.alias_shopify || '') : '';
  document.getElementById('transporteur-actif').checked = tr ? !!tr.actif : true;
  document.getElementById('transporteur-nom-err').classList.remove('show');
  // Copie profonde des tranches pour édition (sans toucher l'original).
  const g = (tr && tr.grille) ? tr.grille : { france: [], euro: [] };
  trancheDraft = {
    france: (g.france || []).map(t => ({ max_g: t.max_g, prix: t.prix })),
    euro: (g.euro || []).map(t => ({ max_g: t.max_g, prix: t.prix })),
  };
  renderTranchesDraft('france');
  renderTranchesDraft('euro');
  openModal('modal-transporteur');
}

function renderTranchesDraft(zone) {
  const cont = document.getElementById('transporteur-grille-' + zone);
  const arr = trancheDraft[zone] || [];
  if (!arr.length) {
    cont.innerHTML = '<div style="font-size:12px;color:var(--text3);padding:6px 0">Aucune tranche. Clique « ＋ tranche ».</div>';
    return;
  }
  cont.innerHTML = arr.map((t, i) =>
    '<div style="display:flex;align-items:center;gap:6px;margin-bottom:6px">' +
      '<span style="font-size:12px;color:var(--text3);white-space:nowrap">jusqu\'à</span>' +
      '<input type="number" min="1" step="1" value="' + (t.max_g != null ? t.max_g : '') + '" ' +
        'oninput="majTrancheDraft(\'' + zone + '\',' + i + ',\'max_g\',this.value)" ' +
        'class="form-input" style="width:90px;padding:6px 8px" placeholder="g" />' +
      '<span style="font-size:12px;color:var(--text3)">g →</span>' +
      '<input type="number" min="0" step="0.01" value="' + (t.prix != null ? t.prix : '') + '" ' +
        'oninput="majTrancheDraft(\'' + zone + '\',' + i + ',\'prix\',this.value)" ' +
        'class="form-input" style="width:90px;padding:6px 8px" placeholder="€" />' +
      '<span style="font-size:12px;color:var(--text3)">€</span>' +
      '<button type="button" class="btn btn-ghost btn-sm" onclick="supprimerTrancheDraft(\'' + zone + '\',' + i + ')" title="Retirer">🗑️</button>' +
    '</div>'
  ).join('');
}

function ajouterTrancheTransporteur(zone) {
  if (!trancheDraft[zone]) trancheDraft[zone] = [];
  trancheDraft[zone].push({ max_g: null, prix: null });
  renderTranchesDraft(zone);
}
function majTrancheDraft(zone, i, champ, val) {
  if (!trancheDraft[zone] || !trancheDraft[zone][i]) return;
  trancheDraft[zone][i][champ] = val === '' ? null : parseFloat(val);
}
function supprimerTrancheDraft(zone, i) {
  trancheDraft[zone].splice(i, 1);
  renderTranchesDraft(zone);
}

async function enregistrerTransporteur() {
  const nom = document.getElementById('transporteur-nom').value.trim();
  if (!nom) { document.getElementById('transporteur-nom-err').classList.add('show'); return; }
  // Nettoyer + trier les tranches (ignorer les incomplètes), tri par poids croissant.
  const nettoie = arr => (arr || [])
    .filter(t => t.max_g != null && !isNaN(t.max_g) && t.prix != null && !isNaN(t.prix))
    .map(t => ({ max_g: Math.round(Number(t.max_g)), prix: Number(t.prix) }))
    .sort((a, b) => a.max_g - b.max_g);
  const grille = { france: nettoie(trancheDraft.france), euro: nettoie(trancheDraft.euro) };
  const id = document.getElementById('transporteur-id').value;
  const payload = {
    nom: nom,
    mode_livraison: document.getElementById('transporteur-mode').value.trim() || null,
    alias_shopify: document.getElementById('transporteur-alias').value.trim() || null,
    actif: document.getElementById('transporteur-actif').checked,
    grille: grille,
  };
  let error;
  if (id) {
    ({ error } = await sb.from('transporteurs').update(payload).eq('id', id));
  } else {
    payload.ordre = (allTransporteurs.length || 0) + 1;
    ({ error } = await sb.from('transporteurs').insert([payload]));
  }
  if (error) { showToast('Erreur : ' + error.message, 'error'); return; }
  closeModal('modal-transporteur');
  showToast(id ? '✅ Transporteur mis à jour.' : '✅ Transporteur ajouté.', 'success');
  chargerTransporteurs();
}

// Bascule entre les sous-onglets Achats / Ventes dans la section Transactions
let transactionsTabActif = 'achats';
function switchTransactionsTab(tab) {
  transactionsTabActif = tab;
  const estAchats = tab === 'achats';
  document.getElementById('transactions-achats-vue').style.display = estAchats ? 'block' : 'none';
  document.getElementById('transactions-ventes-vue').style.display = estAchats ? 'none' : 'block';
  const btnA = document.getElementById('subtab-achats');
  const btnV = document.getElementById('subtab-ventes');
  btnA.classList.toggle('active', estAchats);
  btnV.classList.toggle('active', !estAchats);
  if (estAchats) chargerTransactions();
  else chargerVentes();
}

async function resetVenteStep1() {
  selectedParfumVente = null;
  stockVente = 0;
  venteExpandedKey = null;
  document.getElementById('vente-step1').style.display = 'block';
  document.getElementById('vente-step2').style.display = 'none';
  document.getElementById('vente-search').value = '';
  // Réinitialiser le type de vente sur "Standard" et déverrouiller le champ prix
  // (au cas où "Offert" aurait été sélectionné précédemment).
  document.querySelectorAll('#vente-type .toggle-btn').forEach(b => b.classList.toggle('active', b.dataset.val === 'standard'));
  // Répartition : masquer le bloc et vider les champs.
  // Port : décocher et masquer.
  const portToggle = document.getElementById('vente-port-toggle');
  if (portToggle) { portToggle.checked = false; toggleVentePort(false); }
  const venRep = document.getElementById('vente-repartition');
  if (venRep) { venRep.style.display = 'none'; const rm = document.getElementById('vente-rep-marouane'); const ry = document.getElementById('vente-rep-yassine'); if (rm) rm.value = ''; if (ry) ry.value = ''; const ri = document.getElementById('vente-rep-info'); if (ri) ri.innerHTML = ''; }
  const cp = document.getElementById('vente-prix');
  if (cp) { cp.removeAttribute('disabled'); cp.style.opacity = ''; }

  // Charger tous les parfums avec leur stock pour la recherche
  const parfums = await lireParfumsActifs();
  const stockMap = await lireStockMap();
  // Ne proposer que les références ayant du stock > 0
  allParfumsVente = (parfums || []).filter(p => (stockMap[p.id] || 0) > 0).map(p => ({ ...p, stock: stockMap[p.id] || 0 }));
  filtrerParfumsVente('');
}

let venteExpandedKey = null; // "marque||nom||concentration" du groupe déplié à la vente

function filtrerParfumsVente(query) {
  const q = (query || '').toLowerCase().trim();
  // Recherche multi-mots (marque + nom + concentration), comme dans l'onglet Prix.
  const mots = q.split(/\s+/).filter(Boolean);
  const filtered = !mots.length ? allParfumsVente : allParfumsVente.filter(p => {
    const cible = ((p.marque || '') + ' ' + (p.nom || '') + ' ' + (p.type_olfactif || '')).toLowerCase();
    return mots.every(m => cible.includes(m));
  });
  const container = document.getElementById('vente-liste-parfums');
  if (!filtered.length) {
    container.innerHTML = '<div class="empty"><div class="empty-icon">📦</div><p>' + (q ? 'Aucune référence trouvée.' : 'Aucun stock disponible.') + '</p></div>';
    return;
  }
  // Même déroulé que l'onglet Achat, sur 3 niveaux :
  // 1) concentration  2) type (blister/tester/décant)  3) format (ml) si plusieurs.
  const groupes = {};
  filtered.forEach(p => {
    const gkey = p.marque + '||' + p.nom;
    if (!groupes[gkey]) groupes[gkey] = { marque: p.marque, nom: p.nom, concs: {} };
    const conc = p.type_olfactif || '';
    if (!groupes[gkey].concs[conc]) groupes[gkey].concs[conc] = [];
    groupes[gkey].concs[conc].push(p);
  });

  container.innerHTML = Object.entries(groupes).map(([gkey, g]) => {
    const concBtns = Object.keys(g.concs).map(conc => {
      const ckey = gkey + '||' + conc;
      const ckeyEsc = ckey.replace(/'/g, "\\'");
      const actif = venteExpandedKey === ckey;
      return '<button onclick="toggleConcVente(\'' + ckeyEsc + '\')" style="padding:4px 10px;border-radius:20px;border:1px solid ' + (actif ? 'var(--gold)' : 'var(--border2)') + ';background:' + (actif ? 'var(--gold-bg)' : 'var(--bg3)') + ';color:' + (actif ? 'var(--gold)' : 'var(--text2)') + ';font-size:11px;cursor:pointer;font-family:var(--font);white-space:nowrap">' + (conc || 'N/A') + '</button>';
    }).join('');

    let expandPanel = '';
    if (venteExpandedKey && venteExpandedKey.indexOf(gkey + '||') === 0) {
      const selConc = venteExpandedKey.substring((gkey + '||').length);
      const variantesConc = g.concs[selConc] || [];
      const types = [...new Set(variantesConc.map(v => v.type_produit))];
      const typeBtns = types.map(t => {
        const label = t === 'blister' ? 'Blister' : t === 'tester' ? 'Tester' : 'Décant';
        const cls = t === 'blister' ? 'badge-blister' : t === 'tester' ? 'badge-tester' : 'badge-decant';
        const ckeyEsc = venteExpandedKey.replace(/'/g, "\\'");
        const stockType = variantesConc.filter(v => v.type_produit === t).reduce((s, v) => s + (v.stock || 0), 0);
        const suffixe = t === 'decant' ? ' \u00B7 ' + stockType + ' ml' : '';
        return '<button class="badge ' + cls + '" style="cursor:pointer;padding:8px 16px;font-size:13px;border:none;min-height:36px" onclick="venteChoisirType(\'' + ckeyEsc + '\',\'' + t + '\')">' + label + suffixe + '</button>';
      }).join('');
      expandPanel = '<div style="padding:10px 0 6px;display:flex;gap:8px;flex-wrap:wrap;align-items:center"><span style="font-size:12px;color:var(--text3)">Type :</span>' + typeBtns + '</div>';
    }

    const gkeyId = 'v_' + gkey.replace(/[^a-zA-Z0-9]/g, '_');
    return '<div style="border-bottom:1px solid var(--border);padding:10px 0" id="groupe-' + gkeyId + '">' +
      '<div style="display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap">' +
        '<div style="font-size:13px;font-weight:500;color:var(--text);min-width:120px">' + g.marque + ' \u2014 ' + g.nom + '</div>' +
        '<div style="display:flex;gap:6px;flex-wrap:wrap">' + concBtns + '</div>' +
      '</div>' +
      expandPanel +
    '</div>';
  }).join('');
}

function toggleConcVente(ckey) {
  venteExpandedKey = venteExpandedKey === ckey ? null : ckey;
  filtrerParfumsVente(document.getElementById('vente-search').value);
}

// Niveau 3 : choix du format (ml). Comme a l'achat, on ne l'affiche que s'il y a
// plusieurs contenances pour ce type ; sinon on selectionne directement.
function venteChoisirType(ckey, type) {
  const parts = ckey.split('||');
  const marque = parts[0], nom = parts[1], conc = parts[2] || '';
  const variantes = allParfumsVente.filter(p =>
    p.marque === marque && p.nom === nom && (p.type_olfactif || '') === conc && p.type_produit === type
  );
  if (!variantes.length) return;
  if (type === 'decant' || variantes.length === 1) { selectParfumVente(variantes[0].id); return; }

  const gkeyId = 'v_' + (marque + '||' + nom).replace(/[^a-zA-Z0-9]/g, '_');
  const groupDiv = document.getElementById('groupe-' + gkeyId);
  if (!groupDiv) return;
  const existing = groupDiv.querySelector('.format-panel');
  if (existing) existing.remove();
  const cls = type === 'blister' ? 'badge-blister' : 'badge-tester';
  const fmtBtns = variantes
    .sort((a, b) => (a.contenance_ml || 0) - (b.contenance_ml || 0))
    .map(v => '<button class="badge ' + cls + '" style="cursor:pointer;padding:8px 16px;font-size:13px;border:none;min-height:36px" onclick="selectParfumVente(\'' + v.id + '\')">' +
      (v.contenance_ml ? v.contenance_ml + 'ml' : 'N/A') + ' <span style="opacity:.75">\u00B7 ' + v.stock + ' u</span></button>').join('');
  const panel = document.createElement('div');
  panel.className = 'format-panel';
  panel.style.cssText = 'padding:8px 0 4px;display:flex;gap:8px;flex-wrap:wrap;align-items:center';
  panel.innerHTML = '<span style="font-size:12px;color:var(--text3)">Format :</span>' + fmtBtns;
  groupDiv.appendChild(panel);
}

function selectParfumVente(id) {
  const p = allParfumsVente.find(x => x.id === id);
  if (!p) return;
  selectedParfumVente = p;
  stockVente = p.stock;

  document.getElementById('vente-step1').style.display = 'none';
  document.getElementById('vente-step2').style.display = 'block';
  document.getElementById('vente-step2-title').textContent = 'Vente — ' + p.marque + ' ' + p.nom;

  const isDecant = p.type_produit === 'decant';
  const uniteLabel = (isDecant ? stockVente + ' ml' : stockVente + ' u') + ' disponible' + (stockVente > 1 ? 's' : '');
  document.getElementById('vente-recap-text').textContent = p.marque + ' — ' + p.nom + (p.contenance_ml && !isDecant ? ' ' + p.contenance_ml + 'ml' : '') + ' — ' + (isDecant ? 'Décant' : p.type_produit === 'blister' ? 'Blister' : 'Tester');
  document.getElementById('vente-stock-info').textContent = '📦 Stock disponible : ' + uniteLabel;
  document.getElementById('vente-stock-err').classList.remove('show');

  // Afficher le bon champ de quantité selon le type
  document.getElementById('vente-qty-group').style.display = isDecant ? 'none' : 'block';
  document.getElementById('vente-ml-group').style.display = isDecant ? 'block' : 'none';
  document.getElementById('vente-qty').value = '';
  document.getElementById('vente-ml').value = '';
  document.getElementById('vente-prix').value = '';

  // Mode de saisie du prix de vente (unitaire/par ml OU total) + défaut selon le type.
  venteEstDecant = isDecant;
  setVentePrixMode(isDecant ? 'total' : 'unitaire');

  // Présélectionner le vendeur connecté
  setDefaultVendeur('vente-vendeur');
  // Réinitialiser canal, type de vente et date
  document.querySelectorAll('#vente-canal .toggle-btn').forEach(b => b.classList.remove('active'));
  document.querySelectorAll('#vente-type .toggle-btn').forEach(b => b.classList.remove('active'));
  document.querySelector('#vente-type .toggle-btn[data-val="standard"]').classList.add('active');
  calVenteState = { selected: null, month: new Date().getMonth(), year: new Date().getFullYear() };
  document.getElementById('vente-date-label').textContent = 'Sélectionner un mois';
  document.getElementById('vente-date-label').style.color = 'var(--text3)';
  // Masquer calendrier et erreurs
  document.getElementById('vente-cal-wrap').style.display = 'none';
  ['vente-qty-err','vente-ml-err','vente-prix-err','vente-canal-err','vente-vendeur-err','vente-date-err'].forEach(id => document.getElementById(id).classList.remove('show'));
}

let ventePrixMode = 'unitaire'; // 'unitaire' (par unité / par ml) | 'total'

// ═══════════ FRAIS DE PORT (cas A : le client paie le port) ═══════════
let ventePortPayePar = null; // 'marouane' | 'yassine'
function toggleVentePort(actif) {
  const bloc = document.getElementById('vente-port-bloc');
  if (bloc) bloc.style.display = actif ? 'block' : 'none';
  if (!actif) {
    document.getElementById('vente-port-montant').value = '';
    ventePortPayePar = null;
    document.querySelectorAll('#vente-port-paye .toggle-btn').forEach(b => b.classList.remove('active'));
    document.getElementById('vente-port-info').innerHTML = '';
  } else {
    majVentePortInfo();
  }
}
function setVentePortPaye(val) {
  ventePortPayePar = val;
  document.querySelectorAll('#vente-port-paye .toggle-btn').forEach(b => b.classList.toggle('active', b.getAttribute('data-val') === val));
  majVentePortInfo();
}
function majVentePortInfo() {
  const info = document.getElementById('vente-port-info');
  if (!info) return;
  const montant = parseFloat(document.getElementById('vente-port-montant').value) || 0;
  if (montant <= 0) { info.innerHTML = '<span style="color:var(--text3)">Saisis le montant du port.</span>'; return; }
  if (!ventePortPayePar) { info.innerHTML = '<span style="color:var(--text3)">Indique qui a payé l\'envoi.</span>'; return; }
  // Le vendeur (qui encaisse le paiement client) est déterminé au moment de l'enregistrement.
  // Aperçu générique ici : le port revient à celui qui a payé l'envoi.
  const payeParLabel = ventePortPayePar === 'marouane' ? 'Marouane' : 'Yassine';
  info.innerHTML = '<span style="color:var(--green)">✓ Port de ' + montant.toFixed(2) + ' € — revient à ' + payeParLabel + ' (hors CA).</span>';
}

// ── Frais de port (édition vente) ──
let editVentePortPayePar = null;
function toggleEditVentePort(actif) {
  const bloc = document.getElementById('editvente-port-bloc');
  if (bloc) bloc.style.display = actif ? 'block' : 'none';
  if (!actif) {
    document.getElementById('editvente-port-montant').value = '';
    editVentePortPayePar = null;
    document.querySelectorAll('#editvente-port-paye .toggle-btn').forEach(b => b.classList.remove('active'));
    document.getElementById('editvente-port-info').innerHTML = '';
  } else { majEditVentePortInfo(); }
}
function setEditVentePortPaye(val) {
  editVentePortPayePar = val;
  document.querySelectorAll('#editvente-port-paye .toggle-btn').forEach(b => b.classList.toggle('active', b.getAttribute('data-val') === val));
  majEditVentePortInfo();
}
function majEditVentePortInfo() {
  const info = document.getElementById('editvente-port-info');
  if (!info) return;
  const montant = parseFloat(document.getElementById('editvente-port-montant').value) || 0;
  if (montant <= 0) { info.innerHTML = '<span style="color:var(--text3)">Saisis le montant du port.</span>'; return; }
  if (!editVentePortPayePar) { info.innerHTML = '<span style="color:var(--text3)">Indique qui a payé l\'envoi.</span>'; return; }
  const payeParLabel = editVentePortPayePar === 'marouane' ? 'Marouane' : 'Yassine';
  info.innerHTML = '<span style="color:var(--green)">✓ Port de ' + montant.toFixed(2) + ' € — revient à ' + payeParLabel + ' (hors CA).</span>';
}
let venteEstDecant = false;
function setVentePrixMode(mode) {
  ventePrixMode = mode;
  const u = document.getElementById('vente-prixmode-unit'), t = document.getElementById('vente-prixmode-tot');
  if (u && t) { u.classList.toggle('active', mode === 'unitaire'); t.classList.toggle('active', mode === 'total'); u.textContent = venteEstDecant ? 'Par ml' : 'Unitaire'; }
  const lbl = document.getElementById('vente-prix-label');
  if (lbl) lbl.innerHTML = (mode === 'total' ? 'Prix de vente TOTAL (€)' : (venteEstDecant ? 'Prix de vente par ml (€)' : 'Prix de vente par unité (€)')) + ' <span class="required">*</span>';
  const inp = document.getElementById('vente-prix');
  if (inp) inp.placeholder = mode === 'total' ? (venteEstDecant ? 'ex: 85 (total des ml vendus)' : 'ex: 240 (total)') : (venteEstDecant ? 'ex: 0.85 (par ml)' : 'ex: 120 (par unité)');
}

function setVenteCanal(btn, val) {
  document.querySelectorAll('#vente-canal .toggle-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  document.getElementById('vente-canal-err').classList.remove('show');
}

function setVenteType(btn, val) {
  document.querySelectorAll('#vente-type .toggle-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  // Type "offert" : prix forcé à 0 et champ verrouillé (comme un achat gratuit).
  const champPrix = document.getElementById('vente-prix');
  if (champPrix) {
    if (val === 'offert') {
      champPrix.value = '0';
      champPrix.setAttribute('disabled', 'disabled');
      champPrix.style.opacity = '0.5';
      const err = document.getElementById('vente-prix-err'); if (err) err.classList.remove('show');
    } else {
      champPrix.removeAttribute('disabled');
      champPrix.style.opacity = '';
    }
  }
}

function setVenteVendeur(btn, val) {
  document.querySelectorAll('#vente-vendeur .toggle-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  document.getElementById('vente-vendeur-err').classList.remove('show');
  const bloc = document.getElementById('vente-repartition');
  if (bloc) bloc.style.display = (val === 'personnalise') ? 'block' : 'none';
  if (val === 'personnalise') majVenteRepartitionInfo();
}

// ═══════════ RÉPARTITION PERSONNALISÉE (vente) ═══════════
function montantTotalVenteEnCours() {
  const qte = parseInt(document.getElementById('vente-qty').value) || 0;
  const prix = parseFloat(document.getElementById('vente-prix').value) || 0;
  return ventePrixMode === 'total' ? prix : prix * qte;
}
function onVenteRepartitionInput(qui) {
  const total = montantTotalVenteEnCours();
  const mEl = document.getElementById('vente-rep-marouane');
  const yEl = document.getElementById('vente-rep-yassine');
  if (total > 0) {
    if (qui === 'marouane') {
      const m = parseFloat(mEl.value);
      if (!isNaN(m)) yEl.value = Math.max(0, +(total - m).toFixed(2));
    } else {
      const y = parseFloat(yEl.value);
      if (!isNaN(y)) mEl.value = Math.max(0, +(total - y).toFixed(2));
    }
  }
  majVenteRepartitionInfo();
}
function majVenteRepartitionInfo() {
  const info = document.getElementById('vente-rep-info');
  if (!info) return;
  const total = montantTotalVenteEnCours();
  const m = parseFloat(document.getElementById('vente-rep-marouane').value) || 0;
  const y = parseFloat(document.getElementById('vente-rep-yassine').value) || 0;
  const somme = +(m + y).toFixed(2);
  if (total <= 0) { info.innerHTML = '<span style="color:var(--text3)">Saisis d\'abord le prix de la vente.</span>'; return; }
  if (Math.abs(somme - total) < 0.01) {
    // Vente : impact = (reçu Marouane - reçu Yassine) / 2.
    const impact = (m - y) / 2;
    let apercu = 'neutre (50/50)';
    if (Math.abs(impact) >= 0.01) apercu = impact > 0 ? ('Marouane devra ' + impact.toFixed(2) + ' € à Yassine') : ('Yassine devra ' + Math.abs(impact).toFixed(2) + ' € à Marouane');
    info.innerHTML = '<span style="color:var(--green)">✓ Somme = ' + total.toFixed(2) + ' €. Cagnotte : ' + apercu + '.</span>';
  } else {
    info.innerHTML = '<span style="color:var(--red)">La somme (' + somme.toFixed(2) + ' €) doit égaler le total de la vente (' + total.toFixed(2) + ' €).</span>';
  }
}

function ouvrirCalendrierVente() {
  const wrap = document.getElementById('vente-cal-wrap');
  wrap.style.display = wrap.style.display === 'none' ? 'block' : 'none';
  if (wrap.style.display === 'block') renderCalVente();
}

function renderCalVente() {
  document.getElementById('vente-cal-year').textContent = calVenteState.year;
  const grid = document.getElementById('vente-cal-months');
  grid.innerHTML = '';
  MOIS_COURT.forEach((m, i) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = m;
    btn.style.cssText = 'padding:6px 2px;text-align:center;font-size:12px;border-radius:6px;cursor:pointer;border:1px solid transparent;background:none;font-family:var(--font);color:var(--text2);transition:all 0.1s;';
    if (calVenteState.selected && calVenteState.selected.m === i && calVenteState.selected.y === calVenteState.year) {
      btn.style.background = 'var(--gold-bg)'; btn.style.borderColor = 'var(--gold)'; btn.style.color = 'var(--gold)';
    }
    btn.onmouseover = () => { if (!(calVenteState.selected && calVenteState.selected.m === i && calVenteState.selected.y === calVenteState.year)) btn.style.background = 'var(--bg3)'; };
    btn.onmouseout = () => { if (!(calVenteState.selected && calVenteState.selected.m === i && calVenteState.selected.y === calVenteState.year)) btn.style.background = 'none'; };
    btn.onclick = () => calVenteSelect(i, calVenteState.year);
    grid.appendChild(btn);
  });
}

function calVenteNav(dir) {
  calVenteState.year += dir;
  renderCalVente();
}

function calVenteSelect(m, y) {
  calVenteState.selected = { m, y };
  document.getElementById('vente-date-label').textContent = MOIS_COURT[m] + ' ' + y;
  document.getElementById('vente-date-label').style.color = 'var(--text)';
  document.getElementById('vente-cal-wrap').style.display = 'none';
  document.getElementById('vente-date-err').classList.remove('show');
  renderCalVente();
}

function verifierStockVente() {
  if (!selectedParfumVente) return;
  const isDecant = selectedParfumVente.type_produit === 'decant';
  const val = parseInt(isDecant ? document.getElementById('vente-ml').value : document.getElementById('vente-qty').value);
  const errEl = document.getElementById('vente-stock-err');
  if (val > stockVente) {
    errEl.classList.add('show');
  } else {
    errEl.classList.remove('show');
  }
}

// Synchronise les ventes du site Shopify (bouton de secours). Récupère les
// commandes payées récentes via l'Edge, crée les ventes manquantes, puis
// recalcule la cagnotte et resynchronise le stock Shopify des parfums touchés.
async function synchroniserVentesSite() {
  const btn = document.getElementById('btn-sync-ventes-site');
  if (btn) { btn.disabled = true; btn.style.opacity = '0.6'; btn.textContent = '⏳ Synchronisation…'; }
  afficherProgression('🌐 Récupération des ventes du site…', null);
  try {
    const { data, error } = await sb.functions.invoke('shopify', {
      body: { action: 'sync_ventes_site', ref: { jours: 30 } }
    });
    if (error) {
      let detail = ''; try { detail = await error.context.text(); } catch (e) {}
      masquerProgression();
      showToast('Synchro échouée : ' + (detail || error.message), 'error');
      return;
    }
    if (!data || !data.ok) {
      masquerProgression();
      showToast('Synchro refusée : ' + JSON.stringify(data && data.erreur), 'error');
      console.warn('Synchro ventes site', data);
      return;
    }
    const creees = data.ventes_creees || 0;
    const annulees = data.ventes_annulees || 0;
    const ajustees = data.ventes_ajustees || 0;
    const touches = data.parfums_touches || [];
    // Si des ventes ont changé (créées, annulées OU ajustées) : recalcul cagnotte + resync stock.
    if (creees > 0 || annulees > 0 || ajustees > 0) {
      await recalculerCagnotteComplete();
      for (const pid of touches) {
        try { await synchroniserStockShopify(pid); } catch (e) { console.warn('Resync stock', pid, e); }
      }
    }
    masquerProgression();
    if (creees > 0 || annulees > 0 || ajustees > 0) {
      const parts = [];
      if (creees > 0) parts.push(creees + ' ajoutée' + (creees > 1 ? 's' : ''));
      if (ajustees > 0) parts.push(ajustees + ' ajustée' + (ajustees > 1 ? 's' : '') + ' (remboursement partiel)');
      if (annulees > 0) parts.push(annulees + ' retirée' + (annulees > 1 ? 's' : '') + ' (stock réintégré)');
      showToast('✅ Synchro site : ' + parts.join(' · ') + ' — ' + data.commandes_examinees + ' commande(s) examinée(s)', 'success');
      // Recharger l'historique des ventes IMMÉDIATEMENT (l'utilisateur est sur l'onglet Ventes),
      // sans avoir à changer d'onglet ni recharger la page.
      await chargerVentes();
      chargerTransactions();
    } else {
      showToast('✓ Aucun changement (' + (data.commandes_examinees || 0) + ' commande(s) examinée(s), déjà à jour)', 'success');
    }
    console.group('🌐 Synchro ventes site');
    console.log('Commandes examinées :', data.commandes_examinees);
    console.log('Ventes créées :', creees);
    console.log('Ventes annulées :', annulees);
    console.log('Ventes ajustées (remb. partiel) :', ajustees);
    console.log('Parfums touchés :', touches);
    console.log('Détails :', data.details);
    console.groupEnd();
  } catch (e) {
    masquerProgression();
    showToast('Erreur synchro : ' + (e && e.message ? e.message : e), 'error');
  } finally {
    if (btn) { btn.disabled = false; btn.style.opacity = '1'; btn.textContent = '🌐 Synchroniser les ventes du site'; }
  }
}

async function enregistrerVente(enchainer) {
  enchainerApresVente = !!enchainer;
  if (!selectedParfumVente) return;
  const isDecant = selectedParfumVente.type_produit === 'decant';
  let valid = true;

  const qteEl = isDecant ? document.getElementById('vente-ml') : document.getElementById('vente-qty');
  const qteErrId = isDecant ? 'vente-ml-err' : 'vente-qty-err';
  const qte = parseInt(qteEl.value);
  if (!qte || qte <= 0) { document.getElementById(qteErrId).classList.add('show'); valid = false; }

  const prixVal = document.getElementById('vente-prix').value;
  if (prixVal === '' || prixVal === null) { document.getElementById('vente-prix-err').classList.add('show'); valid = false; }
  const prix = parseFloat(prixVal);

  const canal = document.querySelector('#vente-canal .toggle-btn.active');
  if (!canal) { document.getElementById('vente-canal-err').classList.add('show'); valid = false; }

  const vendeur = document.querySelector('#vente-vendeur .toggle-btn.active');
  if (!vendeur) { document.getElementById('vente-vendeur-err').classList.add('show'); valid = false; }

  if (!calVenteState.selected) { document.getElementById('vente-date-err').classList.add('show'); valid = false; }

  // Vérifier le stock en temps réel (pas juste au niveau affiché — un autre enregistrement
  // aurait pu modifier le stock entre la sélection et l'enregistrement)
  if (valid && qte > stockVente) {
    document.getElementById('vente-stock-err').classList.add('show');
    showToast('Stock insuffisant — seulement ' + stockVente + (isDecant ? ' ml disponibles.' : ' unités disponibles.'), 'error');
    valid = false;
  }

  if (!valid) return;

  const dateVente = calVenteState.selected.y + '-' + String(calVenteState.selected.m + 1).padStart(2, '0') + '-01';

  // Garde-fou temporel : impossible de vendre à une date antérieure au premier achat du parfum.
  const { data: premierAchatV } = await sb.from('achats').select('date_achat').eq('parfum_id', selectedParfumVente.id).order('date_achat', { ascending: true }).limit(1);
  if (premierAchatV && premierAchatV[0] && dateVente < premierAchatV[0].date_achat) {
    const d = new Date(premierAchatV[0].date_achat);
    showToast('⛔ Vente impossible à cette date : ce parfum n\'a été acquis qu\'à partir de ' + MOIS_COURT[d.getMonth()] + ' ' + d.getFullYear() + '. Choisis une date égale ou postérieure.', 'error');
    document.getElementById('vente-date-err').classList.add('show');
    return;
  }

  const vendeurVal = vendeur.getAttribute('data-val');
  const canalVal = canal.getAttribute('data-val');
  const typeVenteVal = (document.querySelector('#vente-type .toggle-btn.active') || {}).getAttribute
    ? document.querySelector('#vente-type .toggle-btn.active').getAttribute('data-val') : 'standard';

  // Pour un décant : le prix saisi est le prix TOTAL de la vente (ex: 85€ pour 100ml).
  // On stocke prix_unitaire = prix/ml (cohérent avec les achats décant), et montant total = prix saisi.
  // Pour blister/tester : prix saisi = prix par unité, montant = prix × quantité.
  const prixUnitaire = ventePrixMode === 'total' ? (qte > 0 ? prix / qte : 0) : prix;
  const montantTotal = ventePrixMode === 'total' ? prix : (prix * qte);

  // Répartition personnalisée : valider la somme et construire l'objet.
  let repartitionVente = null;
  if (vendeurVal === 'personnalise') {
    const mM = parseFloat(document.getElementById('vente-rep-marouane').value) || 0;
    const mY = parseFloat(document.getElementById('vente-rep-yassine').value) || 0;
    if (montantTotal <= 0) { showToast('Saisis le prix de la vente avant la répartition.', 'error'); return; }
    if (Math.abs((mM + mY) - montantTotal) >= 0.01) {
      showToast('La répartition (' + (mM + mY).toFixed(2) + ' €) doit égaler le total de la vente (' + montantTotal.toFixed(2) + ' €).', 'error');
      return;
    }
    repartitionVente = { marouane: r2c(mM), yassine: r2c(mY) };
  }

  // Frais de port (cas A : le client paie le port). Hors CA ; mouvement cagnotte séparé.
  let fraisPort = null;
  let portPayePar = null;
  if (document.getElementById('vente-port-toggle') && document.getElementById('vente-port-toggle').checked) {
    const montantP = parseFloat(document.getElementById('vente-port-montant').value) || 0;
    if (montantP > 0) {
      if (!ventePortPayePar) { showToast('Indique qui a payé l\'envoi (frais de port).', 'error'); return; }
      fraisPort = r2c(montantP);
      portPayePar = ventePortPayePar;
    }
  }

  if (!verrouAction('vente')) return;
  const { data: venteData, error } = await sb.from('ventes').insert([{
    parfum_id: selectedParfumVente.id,
    date_vente: dateVente,
    quantite: qte,
    prix_unitaire: prixUnitaire,
    canal: canalVal,
    vendeur: vendeurVal,
    type_vente: typeVenteVal,
    repartition: repartitionVente,
    frais_port: fraisPort,
    port_paye_par: portPayePar
  }]).select().single();

  if (error) { libererAction('vente'); showToast('Erreur : ' + error.message, 'error'); return; }

  // La cagnotte est recalculée intégralement depuis l'état réel des achats et ventes
  await recalculerCagnotteComplete();

  showToast('✅ Vente enregistrée.', 'success');

  // ─── Synchro Shopify (jamais bloquante) : le stock a baissé ───
  try {
    if (selectedParfumVente) synchroniserStockShopify(selectedParfumVente.id);
  } catch (eSync) { console.warn('Synchro Shopify vente :', eSync); }

  // ─── Notification e-mail (jamais bloquante) ───
  try {
    const pv = selectedParfumVente;
    notifier('vente', {
      ref: nomNotif(pv), detail: descNotif(pv),
      quantite: qte + ((pv && pv.type_produit === 'decant') ? ' ml' : ' u'),
      montant: (prixUnitaire || 0) * (qte || 0),
      vendeur: vendeurVal, canal: canalVal, mois: formatMoisAnnee(dateVente)
    });
    if (pv) verifierSeuilParfum(pv.id);
  } catch (eNotif) { console.warn('Notification vente :', eNotif); }
  // Mode ENCHAÎNER : garder la même référence pour saisir une autre vente.
  const refPourEnchainerV = enchainerApresVente ? selectedParfumVente : null;
  await resetVenteStep1(); // recharge le stock à jour (après la vente)
  if (refPourEnchainerV) {
    // Re-sélectionne si la réf a encore du stock ; sinon on reste sur le choix (stock épuisé).
    const encoreEnStock = allParfumsVente.find(x => x.id === refPourEnchainerV.id);
    if (encoreEnStock) {
      selectParfumVente(refPourEnchainerV.id);
      showToast('✅ Vente enregistrée — enchaîne sur ' + refPourEnchainerV.marque + ' ' + refPourEnchainerV.nom + '.', 'success');
    } else {
      showToast('✅ Vente enregistrée. Stock épuisé pour ' + refPourEnchainerV.marque + ' ' + refPourEnchainerV.nom + ' — choisis une autre référence.', 'success');
    }
  }
  enchainerApresVente = false;
  libererAction('vente');
}

// ── Édition d'une vente ───────────────────────────────────────────────────────

let calEditVenteState = { selected: null, year: new Date().getFullYear() };
let editVenteParfum = null;
let editVenteStock = 0;

function setToggleActive(groupId, btn) {
  document.querySelectorAll('#' + groupId + ' .toggle-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
}

// ═══════════ RÉPARTITION PERSONNALISÉE (édition vente) ═══════════
function montantTotalEditVenteEnCours() {
  const isDecant = editVenteParfum && editVenteParfum.type_produit === 'decant';
  const prixSaisi = parseFloat(document.getElementById('editvente-prix').value) || 0;
  if (isDecant) return prixSaisi; // décant : prix saisi = total
  const qte = parseInt(document.getElementById('editvente-qty').value) || 0;
  return prixSaisi * qte;
}
function onEditVenteVendeurChange(val) {
  document.querySelectorAll('#editvente-vendeur .toggle-btn').forEach(b => b.classList.toggle('active', b.getAttribute('data-val') === val));
  const bloc = document.getElementById('editvente-repartition');
  if (bloc) bloc.style.display = (val === 'personnalise') ? 'block' : 'none';
  if (val === 'personnalise') majEditVenteRepartitionInfo();
}
function onEditVenteRepartitionInput(qui) {
  const total = montantTotalEditVenteEnCours();
  const mEl = document.getElementById('editvente-rep-marouane');
  const yEl = document.getElementById('editvente-rep-yassine');
  if (total > 0) {
    if (qui === 'marouane') { const m = parseFloat(mEl.value); if (!isNaN(m)) yEl.value = Math.max(0, +(total - m).toFixed(2)); }
    else { const y = parseFloat(yEl.value); if (!isNaN(y)) mEl.value = Math.max(0, +(total - y).toFixed(2)); }
  }
  majEditVenteRepartitionInfo();
}
function majEditVenteRepartitionInfo() {
  const info = document.getElementById('editvente-rep-info');
  if (!info) return;
  const total = montantTotalEditVenteEnCours();
  const m = parseFloat(document.getElementById('editvente-rep-marouane').value) || 0;
  const y = parseFloat(document.getElementById('editvente-rep-yassine').value) || 0;
  const somme = +(m + y).toFixed(2);
  if (total <= 0) { info.innerHTML = '<span style="color:var(--text3)">Saisis d\'abord le prix de la vente.</span>'; return; }
  if (Math.abs(somme - total) < 0.01) {
    const impact = (m - y) / 2;
    let apercu = 'neutre (50/50)';
    if (Math.abs(impact) >= 0.01) apercu = impact > 0 ? ('Marouane devra ' + impact.toFixed(2) + ' € à Yassine') : ('Yassine devra ' + Math.abs(impact).toFixed(2) + ' € à Marouane');
    info.innerHTML = '<span style="color:var(--green)">✓ Somme = ' + total.toFixed(2) + ' €. Cagnotte : ' + apercu + '.</span>';
  } else {
    info.innerHTML = '<span style="color:var(--red)">La somme (' + somme.toFixed(2) + ' €) doit égaler le total (' + total.toFixed(2) + ' €).</span>';
  }
}

async function ouvrirEditionVente(id) {
  const v = allVentes.find(x => x.id === id);
  if (!v) return;
  if (v.shopify_order_id) {
    showToast('🔒 Vente issue du site Shopify : non modifiable ici. Une annulation de la commande sur Shopify la retirera automatiquement.', 'error');
    return;
  }
  editVenteParfum = v.parfums;
  const isDecant = v.parfums && v.parfums.type_produit === 'decant';

  // Stock disponible = stock actuel + la quantité de cette vente (puisqu'on va la réécrire)
  const { data: stockData } = await sb.from('stock_actuel').select('stock_restant').eq('id', v.parfum_id).maybeSingle();
  editVenteStock = ((stockData && stockData.stock_restant) || 0) + v.quantite;

  document.getElementById('editvente-id').value = v.id;
  document.getElementById('editvente-recap').textContent =
    (v.parfums ? v.parfums.marque + ' ' + v.parfums.nom : '—') + ' — ' + (isDecant ? 'Décant' : v.parfums.type_produit === 'blister' ? 'Blister' : 'Tester');
  document.getElementById('editvente-stock-info').textContent = '📦 Stock disponible (cette vente incluse) : ' + editVenteStock + (isDecant ? ' ml' : ' u');

  // Champs quantité selon le type
  document.getElementById('editvente-qty-group').style.display = isDecant ? 'none' : 'block';
  document.getElementById('editvente-ml-group').style.display = isDecant ? 'block' : 'none';
  if (isDecant) document.getElementById('editvente-ml').value = v.quantite;
  else document.getElementById('editvente-qty').value = v.quantite;

  // Prix : pour un décant, prix_unitaire stocké = prix/ml → on réaffiche le prix TOTAL
  document.getElementById('editvente-prix-label').innerHTML = (isDecant ? 'Prix de vente TOTAL (€)' : 'Prix de vente par unité (€)') + ' <span class="required">*</span>';
  document.getElementById('editvente-prix').value = isDecant ? Math.round(v.prix_unitaire * v.quantite * 100) / 100 : v.prix_unitaire;

  // Toggles
  setToggleByVal('editvente-canal', v.canal);
  setToggleByVal('editvente-type', v.type_vente || 'standard');
  setToggleByVal('editvente-vendeur', v.vendeur);
  // Répartition : pré-remplir si la vente était personnalisée.
  const editVenRepBloc = document.getElementById('editvente-repartition');
  if (v.vendeur === 'personnalise' && v.repartition) {
    if (editVenRepBloc) editVenRepBloc.style.display = 'block';
    document.getElementById('editvente-rep-marouane').value = (v.repartition.marouane != null ? v.repartition.marouane : '');
    document.getElementById('editvente-rep-yassine').value = (v.repartition.yassine != null ? v.repartition.yassine : '');
    majEditVenteRepartitionInfo();
  } else {
    if (editVenRepBloc) editVenRepBloc.style.display = 'none';
    const rm = document.getElementById('editvente-rep-marouane'); const ry = document.getElementById('editvente-rep-yassine');
    if (rm) rm.value = ''; if (ry) ry.value = '';
  }
  // Frais de port : pré-remplir si présent.
  const editPortToggle = document.getElementById('editvente-port-toggle');
  if (v.frais_port && v.frais_port > 0) {
    if (editPortToggle) editPortToggle.checked = true;
    document.getElementById('editvente-port-bloc').style.display = 'block';
    document.getElementById('editvente-port-montant').value = v.frais_port;
    editVentePortPayePar = v.port_paye_par || null;
    document.querySelectorAll('#editvente-port-paye .toggle-btn').forEach(b => b.classList.toggle('active', b.getAttribute('data-val') === editVentePortPayePar));
    majEditVentePortInfo();
  } else {
    if (editPortToggle) editPortToggle.checked = false;
    const pb = document.getElementById('editvente-port-bloc'); if (pb) pb.style.display = 'none';
    document.getElementById('editvente-port-montant').value = '';
    editVentePortPayePar = null;
    document.querySelectorAll('#editvente-port-paye .toggle-btn').forEach(b => b.classList.remove('active'));
  }

  // Date
  const dt = new Date(v.date_vente);
  calEditVenteState = { selected: { m: dt.getMonth(), y: dt.getFullYear() }, year: dt.getFullYear() };
  document.getElementById('editvente-date-label').textContent = MOIS_COURT[dt.getMonth()] + ' ' + dt.getFullYear();
  document.getElementById('editvente-date-label').style.color = 'var(--text)';
  document.getElementById('editvente-cal-wrap').style.display = 'none';

  openModal('modal-edit-vente');
}

function setToggleByVal(groupId, val) {
  document.querySelectorAll('#' + groupId + ' .toggle-btn').forEach(b => {
    b.classList.toggle('active', b.getAttribute('data-val') === val);
  });
}

function ouvrirCalendrierEditVente() {
  const wrap = document.getElementById('editvente-cal-wrap');
  wrap.style.display = wrap.style.display === 'none' ? 'block' : 'none';
  if (wrap.style.display === 'block') renderCalEditVente();
}
function renderCalEditVente() {
  document.getElementById('editvente-cal-year').textContent = calEditVenteState.year;
  const grid = document.getElementById('editvente-cal-months');
  grid.innerHTML = '';
  MOIS_COURT.forEach((m, i) => {
    const btn = document.createElement('button');
    btn.type = 'button'; btn.textContent = m;
    btn.style.cssText = 'padding:6px 2px;text-align:center;font-size:12px;border-radius:6px;cursor:pointer;border:1px solid transparent;background:none;font-family:var(--font);color:var(--text2)';
    if (calEditVenteState.selected && calEditVenteState.selected.m === i && calEditVenteState.selected.y === calEditVenteState.year) {
      btn.style.background = 'var(--gold-bg)'; btn.style.borderColor = 'var(--gold)'; btn.style.color = 'var(--gold)';
    }
    btn.onclick = () => {
      calEditVenteState.selected = { m: i, y: calEditVenteState.year };
      document.getElementById('editvente-date-label').textContent = MOIS_COURT[i] + ' ' + calEditVenteState.year;
      document.getElementById('editvente-date-label').style.color = 'var(--text)';
      document.getElementById('editvente-cal-wrap').style.display = 'none';
    };
    grid.appendChild(btn);
  });
}
function calEditVenteNav(dir) { calEditVenteState.year += dir; renderCalEditVente(); }

async function saveEditVente() {
  const id = document.getElementById('editvente-id').value;
  const avantEdit = await snapshotAvantEdition('ventes', id, ['quantite', 'prix_unitaire', 'canal', 'vendeur', 'type_vente', 'date_vente', 'repartition', 'frais_port', 'port_paye_par']);
  const isDecant = editVenteParfum && editVenteParfum.type_produit === 'decant';
  let valid = true;

  const qte = parseInt(isDecant ? document.getElementById('editvente-ml').value : document.getElementById('editvente-qty').value);
  if (!qte || qte <= 0) { document.getElementById(isDecant ? 'editvente-ml-err' : 'editvente-qty-err').classList.add('show'); valid = false; }
  if (qte > editVenteStock) { showToast('Stock insuffisant : max ' + editVenteStock + (isDecant ? ' ml' : ' u'), 'error'); valid = false; }

  const prixSaisi = parseFloat(document.getElementById('editvente-prix').value);
  if (document.getElementById('editvente-prix').value === '' || isNaN(prixSaisi)) { document.getElementById('editvente-prix-err').classList.add('show'); valid = false; }

  const canal = document.querySelector('#editvente-canal .toggle-btn.active');
  const typeV = document.querySelector('#editvente-type .toggle-btn.active');
  const vendeur = document.querySelector('#editvente-vendeur .toggle-btn.active');
  if (!canal || !vendeur || !typeV) valid = false;
  if (!calEditVenteState.selected) valid = false;

  if (!valid) return;

  const prixUnitaire = isDecant ? (prixSaisi / qte) : prixSaisi;
  const montantTotal = isDecant ? prixSaisi : (prixSaisi * qte);
  const dateVente = calEditVenteState.selected.y + '-' + String(calEditVenteState.selected.m + 1).padStart(2, '0') + '-01';

  // Garde-fou temporel : impossible de dater une vente avant le premier achat du parfum.
  if (editVenteParfum) {
    const { data: paEV } = await sb.from('achats').select('date_achat').eq('parfum_id', editVenteParfum.id).order('date_achat', { ascending: true }).limit(1);
    if (paEV && paEV[0] && dateVente < paEV[0].date_achat) {
      const d = new Date(paEV[0].date_achat);
      showToast('⛔ Date impossible : ce parfum n\'a été acquis qu\'à partir de ' + MOIS_COURT[d.getMonth()] + ' ' + d.getFullYear() + '. Choisis une date égale ou postérieure.', 'error');
      return;
    }
  }

  const vendeurVal = vendeur.getAttribute('data-val');
  const canalVal = canal.getAttribute('data-val');
  const typeVal = typeV.getAttribute('data-val');

  // Répartition personnalisée (édition vente) : valider + construire.
  let repartitionEditVente = null;
  if (vendeurVal === 'personnalise') {
    const mM = parseFloat(document.getElementById('editvente-rep-marouane').value) || 0;
    const mY = parseFloat(document.getElementById('editvente-rep-yassine').value) || 0;
    if (montantTotal <= 0) { showToast('Saisis le prix avant la répartition.', 'error'); return; }
    if (Math.abs((mM + mY) - montantTotal) >= 0.01) {
      showToast('La répartition (' + (mM + mY).toFixed(2) + ' €) doit égaler le total (' + montantTotal.toFixed(2) + ' €).', 'error');
      return;
    }
    repartitionEditVente = { marouane: r2c(mM), yassine: r2c(mY) };
  }

  // Frais de port (édition) : hors CA, mouvement cagnotte séparé.
  let fraisPortEdit = null;
  let portPayeParEdit = null;
  if (document.getElementById('editvente-port-toggle') && document.getElementById('editvente-port-toggle').checked) {
    const montantP = parseFloat(document.getElementById('editvente-port-montant').value) || 0;
    if (montantP > 0) {
      if (!editVentePortPayePar) { showToast('Indique qui a payé l\'envoi (frais de port).', 'error'); return; }
      fraisPortEdit = r2c(montantP);
      portPayeParEdit = editVentePortPayePar;
    }
  }

  // Mettre à jour la vente
  const { error } = await sb.from('ventes').update({
    quantite: qte, prix_unitaire: prixUnitaire, canal: canalVal, vendeur: vendeurVal, type_vente: typeVal, date_vente: dateVente,
    repartition: repartitionEditVente,
    frais_port: fraisPortEdit,
    port_paye_par: portPayeParEdit
  }).eq('id', id);
  if (error) { showToast('Erreur : ' + error.message, 'error'); return; }

  // La cagnotte est recalculée intégralement depuis l'état réel — déterministe et infaillible
  await recalculerCagnotteComplete();

  closeModal('modal-edit-vente');
  showToast('✅ Vente modifiée.', 'success');
  try { if (editVenteParfum) await synchroniserStockShopify(editVenteParfum.id); } catch (eSy) { console.warn('Synchro Shopify edit vente', eSy); }
  try {
    const pE = editVenteParfum;
    const chg = listerChangements(avantEdit, { quantite: qte, prix_unitaire: prixUnitaire,
      canal: canalVal, vendeur: vendeurVal, type_vente: typeVal, date_vente: dateVente });
    if (chg !== '') notifier('edit_vente', {
      ref: nomNotif(pE), detail: descNotif(pE), changements: chg,
      quantite: qte + ((pE && pE.type_produit === 'decant') ? ' ml' : ' u'),
      montant: (prixUnitaire || 0) * (qte || 0), vendeur: vendeurVal,
      canal: canalVal, mois: formatMoisAnnee(dateVente)
    });
    if (pE) verifierSeuilParfum(pE.id);
  } catch (eN) { console.warn('Notification édition vente :', eN); }
  chargerVentes();
}



let allVentes = [];
let ventesSearchQuery = '';

async function chargerVentes() {
  document.getElementById('ventes-content').innerHTML = '<div class="loading"><div class="spinner"></div> Chargement...</div>';
  let data;
  try {
    data = await selectTout('ventes', '*, parfums(marque, nom, type_produit, contenance_ml, type_olfactif)', {col:'date_vente',asc:false});
  } catch (error) { document.getElementById('ventes-content').innerHTML = '<div class="err-box">Erreur : ' + (error && error.message || error) + '</div>'; return; }
  allVentes = data || [];
  document.getElementById('ventes-count').textContent = allVentes.length + ' vente' + (allVentes.length > 1 ? 's' : '');
  setupVentesFilters();
  filtrerVentes(ventesSearchQuery);
}

function setupVentesFilters() {
  const MOIS_LONG = ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];
  const fmtMoisAnnee = d => { const dt = new Date(d); return MOIS_LONG[dt.getMonth()] + ' ' + dt.getFullYear(); };
  columnFilterConfig.ventes = {
    source: () => allVentes,
    refilter: () => filtrerVentes(ventesSearchQuery),
    columns: [
      { key: 'marque', label: 'Marque', type: 'select', getValue: v => v.parfums ? v.parfums.marque : null, formatLabel: v => v },
      { key: 'type_produit', label: 'Type', type: 'select', getValue: v => v.parfums ? v.parfums.type_produit : null, formatLabel: v => v === 'blister' ? 'Blister' : v === 'tester' ? 'Tester' : 'Décant' },
      { key: 'date_vente', label: 'Date', type: 'select', getValue: v => v.date_vente, formatLabel: fmtMoisAnnee },
      { key: 'canal', label: 'Canal', type: 'select', getValue: v => v.canal, formatLabel: v => v === 'site' ? 'Site' : v === 'reseaux' ? 'Réseaux' : 'Main propre' },
      { key: 'type_vente', label: 'Vente', type: 'select', getValue: v => v.type_vente || 'standard', formatLabel: v => v === 'revendeur' ? 'Revendeur' : (v === 'offert' ? '🎁 Offert' : 'Standard') },
      { key: 'vendeur', label: 'Qui', type: 'select', getValue: v => v.vendeur, formatLabel: v => v === 'commun' ? 'Compte commun' : v === 'marouane' ? 'Marouane' : 'Yassine' }
    ]
  };
}

function filtrerVentes(q) {
  ventesSearchQuery = q;
  const ql = q.toLowerCase();
  let result = allVentes.filter(v =>
    (v.parfums && v.parfums.marque.toLowerCase().includes(ql)) || (v.parfums && v.parfums.nom.toLowerCase().includes(ql))
  );
  result = applyColumnFilters('ventes', result);
  renderVentes(result);
  renderActiveFiltersBar('ventes');
}

function renderVentes(list) {
  bulkCurrentList.ventes = list;
  bulkPurgerSelection('ventes');
  const container = document.getElementById('ventes-content');
  if (!list.length) {
    container.innerHTML = '<div class="empty"><div class="empty-icon">💰</div><p>Aucune vente enregistrée.</p></div>';
    return;
  }
  const typeBadge = t => t === 'blister' ? '<span class="badge badge-blister">Blister</span>' : t === 'tester' ? '<span class="badge badge-tester">Tester</span>' : '<span class="badge badge-decant">Décant</span>';
  const canalBadge = c => {
    if (c === 'site') return '<span class="badge badge-site">🌐 Site</span>';
    if (c === 'reseaux') return '<span class="badge badge-reseaux">📱 Réseaux</span>';
    return '<span class="badge">🤝 Main propre</span>';
  };
  const badgeMA = '<span style="background:#E6F1FB;color:#0C447C;border-radius:50%;width:24px;height:24px;display:inline-flex;align-items:center;justify-content:center;font-size:10px;font-weight:600">MA</span>';
  const badgeYA = '<span style="background:#FAEEDA;color:#633806;border-radius:50%;width:24px;height:24px;display:inline-flex;align-items:center;justify-content:center;font-size:10px;font-weight:600">YA</span>';
  const badgeReparti = '<span style="background:rgba(232,168,76,0.15);color:var(--amber);border:1px solid rgba(232,168,76,0.35);border-radius:12px;height:24px;padding:0 8px;display:inline-flex;align-items:center;gap:3px;font-size:10px;font-weight:600" title="Répartition personnalisée">⚖️ Réparti</span>';
  const vendeurBadge = v => v === 'marouane' ? badgeMA
    : v === 'commun' ? ('<span style="display:inline-flex;gap:2px">' + badgeMA + badgeYA + '</span>')
    : v === 'personnalise' ? badgeReparti
    : badgeYA;
  const fmtDate = d => { const dt = new Date(d); return (dt.getMonth()+1).toString().padStart(2,'0') + '/' + dt.getFullYear().toString().slice(2); };
  const fmtPrix = n => n != null ? n.toFixed(2).replace('.',',') + ' €' : '0,00 €';

  let html = '<div class="table-wrap"><table>' +
    '<thead><tr>' +
    '<th class="select-col"><input type="checkbox" onchange="bulkToggleAll(\'ventes\',this.checked)"></th>' +
    '<th>' + colFilterIcon('ventes','date_vente') + 'Date</th>' +
    '<th>Parfum</th>' +
    '<th>' + colFilterIcon('ventes','type_produit') + 'Type</th>' +
    '<th>Qté/ML</th>' +
    '<th>Prix unit.</th>' +
    '<th>Total</th>' +
    '<th>' + colFilterIcon('ventes','canal') + 'Canal</th>' +
    '<th>' + colFilterIcon('ventes','type_vente') + 'Vente</th>' +
    '<th>' + colFilterIcon('ventes','vendeur') + 'Qui</th>' +
    '<th></th>' +
    '</tr></thead><tbody>';

  html += list.map(v => {
    const marque = v.parfums ? v.parfums.marque : '—';
    const nom = v.parfums ? v.parfums.nom : '';
    const tproduit = v.parfums ? v.parfums.type_produit : null;
    const conc = v.parfums ? v.parfums.type_olfactif : null;
    const ml = v.parfums ? v.parfums.contenance_ml : null;
    const sousLigne = [conc, ml && tproduit !== 'decant' ? ml + 'ml' : null].filter(Boolean).join(' · ');
    const qteLabel = tproduit === 'decant' ? v.quantite + ' ml' : v.quantite + ' u';
    const checked = bulkSelection.ventes && bulkSelection.ventes.has(v.id) ? 'checked' : '';
    const venteBadge = v.type_vente === 'revendeur'
      ? '<span class="badge" style="background:#FCE4EC;color:#AD1457;border:1px solid rgba(173,20,87,0.3)">Revendeur</span>'
      : v.type_vente === 'offert'
      ? '<span class="badge" style="background:var(--amber-bg);color:var(--amber);border:1px solid rgba(232,168,76,0.3)">🎁 Offert</span>'
      : '<span class="badge" style="background:#E8F5E9;color:#2E7D32;border:1px solid rgba(46,125,50,0.3)">Standard</span>';
    return '<tr>' +
      '<td class="select-col"><input type="checkbox" class="select-checkbox" data-contexte="ventes" ' + checked + ' onchange="bulkToggle(\'ventes\',\'' + v.id + '\',this.checked)"></td>' +
      '<td>' + fmtDate(v.date_vente) + '</td>' +
      '<td>' + lienFiche(v.parfum_id, '<strong>' + marque + '</strong> ' + nom) + (sousLigne ? '<div style="font-size:11px;color:var(--text3);margin-top:2px">' + sousLigne + '</div>' : '') + '</td>' +
      '<td>' + typeBadge(tproduit) + '</td>' +
      '<td>' + qteLabel + '</td>' +
      '<td>' + fmtPrix(v.prix_unitaire) + '</td>' +
      '<td><strong>' + fmtPrix(v.prix_unitaire * v.quantite) + '</strong></td>' +
      '<td>' + canalBadge(v.canal) + '</td>' +
      '<td>' + venteBadge + '</td>' +
      '<td>' + vendeurBadge(v.vendeur) + '</td>' +
      '<td><div class="action-btns">' + (
        v.shopify_order_id
          ? '<span class="btn btn-ghost btn-sm" style="opacity:0.35;cursor:not-allowed" title="Vente issue du site Shopify : non modifiable ici. Gère-la depuis Shopify (une annulation de commande la retirera automatiquement).">🔒</span>'
          : '<button class="btn btn-ghost btn-sm" onclick="ouvrirEditionVente(\'' + v.id + '\')" title="Éditer">✏️</button><button class="btn btn-ghost btn-sm" onclick="supprimerVente(\'' + v.id + '\')" title="Supprimer">🗑️</button>'
      ) + '</div></td>' +
    '</tr>';
  }).join('');
  html += '</tbody></table></div>';
  container.innerHTML = html;
  bulkUpdateBar('ventes');
}

function supprimerVente(id) {
  demanderSuppression('Supprimer cette vente ? Le stock sera restauré et la cagnotte mise à jour.', () => _doSupprimerVente(id));
}
async function _doSupprimerVente(id) {
  const infoS = await libelleAvantSuppression('ventes', id);
  // La vente est dans allVentes (allTransactions ne contient que les ACHATS).
  // On récupère le parfum_id AVANT suppression pour resynchroniser son stock Shopify.
  const venteSuppr = allVentes.find(x => x.id === id);
  const parfumIdVenteSuppr = (venteSuppr && venteSuppr.parfum_id) || (infoS && infoS.parfumId) || null;
  const { error } = await sb.from('ventes').delete().eq('id', id);
  if (error) { showToast('Erreur : ' + error.message, 'error'); return; }
  // La cagnotte est recalculée depuis l'état réel APRÈS suppression
  await recalculerCagnotteComplete();
  showToast('✅ Vente supprimée, stock restauré.', 'success');
  try { if (parfumIdVenteSuppr) await synchroniserStockShopify(parfumIdVenteSuppr); } catch (e) { console.warn('Synchro Shopify suppr vente', e); }
  notifier('suppr_vente', infoS);
  if (infoS && infoS.parfumId) verifierSeuilParfum(infoS.parfumId);
  chargerVentes();
}

bulkDeleteHandlers.ventes = async function(ids) {
  // Récapitulatif groupé + liste des parfums touchés, pour ne pas noyer la boîte mail.
  let totalSuppr = 0; const pidsTouches = []; const detailsSuppr = []; const idsReels = [];
  try { for (const idv of ids) {
    const { data: exist } = await sb.from('ventes').select('id').eq('id', idv).maybeSingle();
    if (!exist) continue;
    idsReels.push(idv);
    const i = await libelleAvantSuppression('ventes', idv);
    totalSuppr += (i.montant || 0); if (i.parfumId) pidsTouches.push(i.parfumId);
    detailsSuppr.push(i.ref + (i.detail ? ' (' + i.detail + ')' : '') + ' \u2014 ' + i.quantite + ' \u2014 ' + fmtNb(i.montant || 0) + ' \u20ac (' + (i.mois || '') + ')');
  } } catch (e) {}
  for (const id of ids) {
    await sb.from('cagnotte').delete().eq('reference_id', id);
    await sb.from('ventes').delete().eq('id', id);
  }
  await recalculerCagnotteComplete();
  showToast('✅ ' + ids.length + ' vente(s) supprimée(s).', 'success');
  if (idsReels.length) notifier('suppr_lot', { nature: 'vente(s)', nombre: idsReels.length, montant: totalSuppr, details: detailsSuppr });
  verifierSeuilsGroupes(pidsTouches);
  // Synchro Shopify pour chaque référence touchée.
  try {
    const dejaFaitV = new Set();
    for (const pid of pidsTouches) {
      if (pid && !dejaFaitV.has(pid)) { dejaFaitV.add(pid); synchroniserStockShopify(pid); }
    }
  } catch (eSy) { console.warn('Synchro Shopify suppr lot ventes', eSy); }
  chargerVentes();
};

async function bulkSupprimerVentes() {
  bulkDeleteConfirm('ventes');
}

sb.auth.getSession().then(({ data }) => {
  const session = data.session;
  if (session) { currentUser = session.user; loadUserProfile(); showApp(); }
});
document.getElementById('login-password').addEventListener('keydown', e => { if (e.key === 'Enter') login(); });